<!-- 超级管理员端 -->
<template>
  <div class="main" style="width: 1180px;">
    <a-card>
      <div class="topBlock">
		<div style="display: flex;" v-if="searchType == 0">
			<a-input-search placeholder="请输入机构名称" style="width: 200px" v-model="searchVal" @search="onSearch" />
			<a-input-search placeholder="请输入SN码" style="width: 200px; margin-left: 15px;" v-model="searchVal2" @search="onSearch2" />
		</div>
        <div class="searchTitle" v-if="searchType == 1">
          <span>关于“{{ searchVal }}”共搜索到</span>
          <span class="colorTitle"> {{ total }} </span>条结果
          <span class="colorTitle" @click="goBack">返回</span>
        </div>
		<div class="searchTitle" v-if="searchType == 2">
          <span>关于“{{ searchVal2 }}”搜索结果如下</span>
          <!-- <span class="colorTitle"> {{ total }} </span>条结果 -->
          <span class="colorTitle" @click="goBack">返回</span>
        </div>
        <a-button v-if="searchType == 0" type="primary" icon="plus" @click="addMechanismBtn(1)">添加机构</a-button>
      </div>
      <div v-if="total != 0">
        <a-table :columns="searchType == 2 ? columns1 : columns" :data-source="tableData" bordered :pagination="false" rowKey="id" :rowClassName="record">
          <template slot="scopedName" slot-scope="scope">
            <span style="color: #1890FF; cursor: pointer;" @click="editBtn(2, scope)">{{ scope.name }}</span>
          </template>
          <template slot="website" slot-scope="scope">
            <span style="color: #1890FF; cursor: pointer;" @click="goUrl(scope.siteUrl)">{{ scope.siteUrl }}</span>
          </template>
          <template slot="deviceCnt" slot-scope="scope">
            <span style="color: #1890FF; cursor: pointer;" v-if="scope.deviceCnt != '-'" @click="deviceCntClick(scope)">{{ scope.deviceCnt }}</span>
            <span v-else>{{ scope.deviceCnt }}</span>
          </template>
		  <template slot="deviceSn" slot-scope="scope">
            <span style="">{{ scope.snCode }}</span>
          </template>
          <template slot="deviceBed" slot-scope="scope">
            <span style="">{{ scope.bedName }}</span>
          </template>
          <template slot="mechanism" slot-scope="scope">
            <div class="add">
              <span v-if="scope.adminUser" @click="adminUserBtn(2, scope)">{{ scope.adminUser.name }}</span>
              <span v-else @click="adminUserBtn(1, scope)">添加</span>
            </div>
          </template>
          <template slot="operation" slot-scope="scope">
            <span style="color: #1890FF;cursor: pointer;margin-right: 10px;" @click="replaceThemeBtn(scope)">更换主题</span>
            <span style="color: #1890FF;cursor: pointer;" v-if="scope.status == 1" @click="statusBtn(1, scope)">禁用</span>
            <span style="color: #1890FF;cursor: pointer;" v-else @click="statusBtn(2, scope)">启用</span>
            <span style="color: #1890FF;cursor: pointer; margin-left: 10px;" @click="functionClick(scope)">功能</span>
          </template>
        </a-table>
        <a-pagination :pageSize="pageSize" v-model="pageNum" :total="total" @change="pageChange" show-less-items style="text-align: center; margin-top: 20px" :hideOnSinglePage="true" />
      </div>
      <a-empty v-else-if="searchType == 1" />
	  <a-empty v-else-if="searchType == 2" :description="'暂无内容哦'" />
    </a-card>

    <!-- 添加机构 -->
    <a-modal :title="typeNum == 1 ? '添加机构' : '修改机构'" :visible="addMechanismPopup" :maskClosable="false" :width="430" @cancel="addMechanismOff" :footer="null">
      <a-form>
        <a-form-item label="">
          <div class="login_input" :style="{borderColor: nameColor}">
            <input type="text" v-model="addListData.name" maxlength="20" placeholder="请输入姓名" />
            <a-icon type="info-circle" theme="filled" style="color: #FF4D4F;" v-if="nameIcon" />
          </div>
          <p class="tips" :style="{color: nameColor}" style="margin-bottom: 40px;">{{ nameTips }}</p>
          <div class="login_input" style="border-color: #BFBFBF;">
            <input type="text" maxlength="30" v-model="addListData.website" placeholder="请输入网址信息" />
            <a-icon type="info-circle" theme="filled" style="color: #FF4D4F;" v-if="webIcon" />
          </div>
          <p class="tips" :style="{color: webColor}">{{ webTips }}</p>
        </a-form-item>
        <a-form-item style="margin-top: 40px;text-align: right;margin-bottom: 0;">
          <a-button style="margin-right: 10px;" @click="addMechanismOff">取消</a-button>
          <a-button type="primary" @click="addMechanismOk" :loading="loading">{{ typeNum == 1 ? '添加' : '修改'}}</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 添加机构管理员  -->
    <a-modal :title="adminUserType == 1 ? '添加机构管理员' : '修改机构管理员'" :visible="adminUserPopup" :maskClosable="false" :width="430" @cancel="adminUserOff" :footer="null">
      <a-form class="adminUser">
        <a-form-item label="">
          <div class="login_input" style="padding-bottom: 13px;" :style="{borderColor: nameColor}">
            <input type="text" v-model="adminUserList.name" placeholder="请输入姓名" />
            <a-icon type="info-circle" theme="filled" style="color: #FF4D4F;" v-if="nameIcon" />
          </div>
          <p class="tips" :style="{color: nameColor}">{{ adminNameTips }}</p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" style="padding-bottom: 13px;" :style="{borderColor: phoneColor}">
            <input type="text" autocomplete="off" v-model="adminUserList.phone" placeholder="请输入手机号" />
            <a-icon type="info-circle" theme="filled" style="color: #FF4D4F;" v-if="phoneIcon" />
          </div>
          <p class="tips" :style="{color: phoneColor}" v-if="phoneIcon">{{ phoneTips }}</p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" style="padding-bottom: 13px;" :style="{borderColor: passwordColor}">
            <input type="text" placeholder="请输入密码" autocomplete="off" v-model="adminUserList.password" />
            <a-icon type="info-circle" theme="filled" style="color: #FF4D4F;" v-if="passwordIcon" />
          </div>
          <p class="tips" :style="{color: passwordColor}" v-if="passwordIcon">{{passwordTips}}</p>
        </a-form-item>
        <a-form-item style="margin-top: 40px;text-align: right;margin-bottom: 0;">
          <a-button style="margin-right: 10px;" @click="adminUserOff">取消</a-button>
          <a-button type="primary" @click="adminUserOk" :loading="loading">{{ adminUserType == 1 ? '添加' : '修改'}}</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 更换主题 -->
    <a-modal title="更换主题" :visible="replaceThemePopup" :maskClosable="false" :width="400" @cancel="replaceThemeOff" :footer="null">
      <a-form>
        <div>
          <div>
            <div style="display: flex;">
              <a-form-item label="当前头图" style="display: flex;margin-bottom: 0;">
                <a-upload action="/api/tenant/uploadImg" accept="image/*" :headers="headers" list-type="picture-card" :file-list="fileList" @preview="handlePreview" @change="handleChange" :showUploadList="{showRemoveIcon:false}">
                <!-- <a-upload action="http://112.126.89.155/api/tenant/uploadImg" accept="image/*" :headers="headers" list-type="picture-card" :file-list="fileList" @preview="handlePreview" @change="handleChange" :showUploadList="{showRemoveIcon:false}"> -->
                  <div v-if="fileList.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
              </a-form-item>
              <div>
                <span v-if="fileList.length > 0" class="editTheme" @click="editThemeBtn">更改</span>
                <div class="jianyi">建议图片尺寸165*45px透明底图片效果较好</div>
              </div>
            </div>
          </div>
          <a-form-item label="当前背景" class="backgroundColor">
            <div class="colorBox">
              <div class="backColor" @click="colorBtn">
                <div :class="['colorTile',backGroundColor == 'linear-gradient(270deg, #C3E2FF 0%, #FFFFFF 37%, #FFFFFF 100%)' ? 'bor2Px' : '']" :style="{background: backGroundColor}"></div>
                <a-icon type="up" v-if="colorHide" />
                <a-icon type="down" v-else />
              </div>
              <div class="colorList" v-if="colorHide">
                <div class="colorItem" v-for="(item, index) in colorListData" :key="index" @click="colorItemBtn(item)">
                  <div :style="{background: item}"></div>
                </div>
              </div>
            </div>
          </a-form-item>
        </div>
        <a-form-item style="margin-top: 40px;text-align: right;margin-bottom: 0;">
          <a-button style="margin-right: 10px;" @click="replaceThemeOff">取消</a-button>
          <a-button type="primary" @click="replaceThemeOk" :loading="loading">确定</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
    <a-modal v-model="functionVisible" :title="activeTitle" :width="938" @ok="submitChange" wrapClassName="super_admin-func_set_modal">

			<div class="fsm-header">
				<div class="fsm-header-dot"></div>
				<span class="fsm-header-title">整体功能模块</span>
			</div>

			<div class="fsm-card" style="padding-bottom: 16px;">
				<div class="fsm-card-header">
					<div class="fsm-card-header-border"></div>
					<span class="fsm-card-header-title">生命体征监测</span>
				</div>
				<div class="fsm-card-table fsm-card-border_right fsm-card-border_bottom">
					<span class="fsm-card-table-header">生命体征报警类别</span>
					<div class="fsm-card-table-header_sub fsm-card-color_FAFAFA">
						<span class="fsm-card-table-header_sub-item_1">类别</span>
						<span class="fsm-card-table-header_sub-item_2">报警阈值</span>
					</div>
					<!-- 跌倒 -->
					<div class="fsm-card-table-row">
						<div class="fsm-card-table-row-item_1">
							<span class="fsm-card-table-row-text_1" :class="{ text_color_ff4d4f: conflictValues.fall }">跌倒</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.fall" @change="fallSwitch" />
						</div>
						<div class="fsm-card-table-row-item_2">
							<span class="fsm-card-table-row-text_1">电话报警</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.phoneAlarm" @change="phoneAlarmSwitch" :disabled="switchCheck.fall ? false : true" style="margin-left: 16px;" />
						</div>
					</div>
					<!-- 卫生间停留过久 -->
					<div class="fsm-card-table-row fsm-card-color_FAFAFA">
						<div class="fsm-card-table-row-item_1">
							<span class="fsm-card-table-row-text_1" :class="{ text_color_ff4d4f: conflictValues.toitet }">卫生间停留过久</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.toitet" @change="toitetFallSwitch" />
						</div>
						<div class="fsm-card-table-row-item_2">
							<span class="fsm-card-table-row-text_1">电话报警</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.toitetPhoneAlarm" @change="toitetPhoneAlarmSwitch" :disabled="switchCheck.toitet ? false : true" style="margin-left: 16px;"  />
						</div>
					</div>
					<!-- 呼吸过速 -->
					<div class="fsm-card-table-row">
						<div class="fsm-card-table-row-item_1">
							<span class="fsm-card-table-row-text_1" :class="{ text_color_ff4d4f: conflictValues.breath }">呼吸过速</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.breath" @change="breathSwitch" />
						</div>
						<div class="fsm-card-table-row-item_2">
							<span class="fsm-card-table-row-text_1">电话报警</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.breathPhoneAlarm" @change="breathPhoneAlarmSwitch" :disabled="switchCheck.breath ? false : true" style="margin-left: 16px;"  />
							<div class="fsm-card-table-row-edit">
								<div class="fsm-card-table-row-edit-left">
									<span v-if="!breathThrsShow" :class="switchCheck.breath ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrs.breathBpm }}BPM&emsp;{{ thrs.breath }}&nbsp;&nbsp;</span>
									<a-time-picker v-if="breathThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.breath" @change="breathThrsChange" style="width: 90px;" />&nbsp;
									<a-input-number v-if="breathThrsShow" :min="27" :max="40" :step="1" size="small" :defaultValue="thrs.breathBpm" @change="breathBpmChange" />&nbsp;
									<a-button v-if="breathThrsShow" size="small" type="primary" @click="breathThrsConfirm">确定</a-button>
								</div>
								<a-icon v-if="!breathThrsShow" type="form" :class="switchCheck.breath ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="breathThrsShow = !breathThrsShow; setDefaultThrsTime()" />
							</div>
							<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.breath }" @click="breathReset">重置为初始默认值</div>
						</div>
					</div>
					<!-- 呼吸暂停过久 -->
					<div class="fsm-card-table-row fsm-card-color_FAFAFA">
						<div class="fsm-card-table-row-item_1">
							<span class="fsm-card-table-row-text_1">呼吸暂停过久</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.apnea" @change="apneaSwitch" />
						</div>
						<div class="fsm-card-table-row-item_2">
							<span class="fsm-card-table-row-text_1">电话报警</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.apneaPhoneAlarm" @change="apneaPhoneAlarmSwitch" :disabled="switchCheck.apnea ? false : true" style="margin-left: 16px;"  />
							<div class="fsm-card-table-row-edit">
								<div class="fsm-card-table-row-edit-left">
									<span v-if="!apneaThrsShow" :class="switchCheck.apnea ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrs.apneaMm }}m&emsp;{{ thrs.apnea }}&nbsp;&nbsp;</span>
									<a-time-picker v-if="apneaThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.apnea" @change="apneaThrsChange" style="width: 90px;" />&nbsp;
									<a-input-number v-if="apneaThrsShow" :min="27" :max="40" :step="1" size="small" :defaultValue="thrs.apnea" @change="apneaMmChange" />&nbsp;
									<a-button v-if="apneaThrsShow" size="small" type="primary" @click="apneaThrsConfirm">确定</a-button>
								</div>
								<a-icon v-if="!apneaThrsShow" type="form" :class="switchCheck.apnea ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="apneaThrsShow = !apneaThrsShow; setDefaultThrsTime()" />
							</div>
							<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.apnea }" @click="apneaReset">重置为初始默认值</div>
						</div>
					</div>
					<!-- 心跳过速 -->
					<div class="fsm-card-table-row fsm-card-color_FAFAFA">
						<div class="fsm-card-table-row-item_1">
							<span class="fsm-card-table-row-text_1" :class="{ text_color_ff4d4f: conflictValues.heart }">心跳过速</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.heart" @change="heartSwitch" />
						</div>
						<div class="fsm-card-table-row-item_2">
							<span class="fsm-card-table-row-text_1">电话报警</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.heartPhoneAlarm" @change="heartPhoneAlarmSwitch" :disabled="switchCheck.heart ? false : true" style="margin-left: 16px;"  />
							<div class="fsm-card-table-row-edit">
								<div class="fsm-card-table-row-edit-left">
									<span v-if="!heartThrsShow" :class="switchCheck.heart ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrs.heartBpm }}BPM&emsp;{{ thrs.heart }}&nbsp;&nbsp;</span>
									<a-time-picker v-if="heartThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.heart" @change="heartThrsChange" style="width: 90px;" />&nbsp;
									<a-input-number v-if="heartThrsShow" :min="0" :step="1" size="small" :defaultValue="thrs.heartBpm" @change="heartBpmChange" />&nbsp;
									<a-button v-if="heartThrsShow" size="small" type="primary" @click="heartThrsConfirm">确定</a-button>
								</div>
								<a-icon v-if="!heartThrsShow" type="form" :class="switchCheck.heart ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="heartThrsShow = !heartThrsShow; setDefaultThrsTime()" />
							</div>
							<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.heart }" @click="heartReset">重置为初始默认值</div>
						</div>
					</div>
					<!-- 心跳过缓 -->
					<div class="fsm-card-table-row">
						<div class="fsm-card-table-row-item_1">
							<span class="fsm-card-table-row-text_1">心跳过缓</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.heartBra" @change="heartBraSwitch" />
						</div>
						<div class="fsm-card-table-row-item_2">
							<span class="fsm-card-table-row-text_1">电话报警</span>
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.heartBraPhoneAlarm" @change="heartBraPhoneAlarmSwitch" :disabled="switchCheck.heartBra ? false : true" style="margin-left: 16px;"  />
							<div class="fsm-card-table-row-edit">
								<div class="fsm-card-table-row-edit-left">
									<span v-if="!heartBraThrsShow" :class="switchCheck.heartBra ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrs.heartBraBpm }}BPM&emsp;{{ thrs.heartBra }}&nbsp;&nbsp;</span>
									<a-time-picker v-if="heartBraThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.heartBra" @change="heartBraThrsChange" style="width: 90px;" />&nbsp;
									<a-input-number v-if="heartBraThrsShow" :min="0" :step="1" size="small" :defaultValue="thrs.heartBraBpm" @change="heartBraBpmChange" />&nbsp;
									<a-button v-if="heartBraThrsShow" size="small" type="primary" @click="heartBraThrsConfirm">确定</a-button>
								</div>
								<a-icon v-if="!heartBraThrsShow" type="form" :class="switchCheck.heartBra ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="heartBraThrsShow = !heartBraThrsShow; setDefaultThrsTime()" />
							</div>
							<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.heartBra }" @click="heartBraReset">重置为初始默认值</div>
						</div>
					</div>
					
				</div>
				<div class="fsm-card-table fsm-card-border_right fsm-card-border_bottom">
					<div class="fsm-card-table-header">
						<span>实时监测正常反馈</span>	
						<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.realTimeMon" @change="realTimeSwitch" style="margin-left: 15px;" />
					</div>
					<div class="fsm-card-table-header_sub">
						<span class="fsm-card-table-header_sub-item_1">类别</span>
						<span class="fsm-card-table-header_sub-item_2">设定阈值</span>
					</div>
					<!-- 呼吸正常阈值 -->
					<div class="fsm-card-table-row">
						<div class="fsm-card-table-row-item_1" style="height: 80px;">
							<span class="fsm-card-table-row-text_1" :class="{ text_color_ff4d4f: conflictValues.breathThrs }">呼吸正常阈值</span>
						</div>
						<div style="display: flex; flex-direction: column;">
							<div class="fsm-card-table-row-item_2" style="padding-left: 0px;">
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px; border-left: unset;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.breath.day.bpmLow }}~{{ thrsNormal.breath.day.bpmUp }}&nbsp;BPM&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.breath.dayBpm = !norShowChange.breath.dayBpm" style="margin-right: 0px;" />
									<el-popover v-if="switchCheck.realTimeMon" v-model="norShowChange.breath.dayBpm" trigger="click">
										<a-input-number v-if="norShowChange.breath.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.day.bpmLow" @change="breathDayBpmLowChange" />&nbsp;
										<a-input-number v-if="norShowChange.breath.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.day.bpmUp" @change="breathDayBpmUpChange" /><br><br>
										<a-button type="primary" @click="breathDayBpmConfirm">确定</a-button>
									</el-popover>&emsp;
								</div>
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.breath.day.timeLow }}~{{ thrsNormal.breath.day.timeUp }}&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.breath.dayTime = !norShowChange.breath.dayTime" />
									<el-popover v-model="norShowChange.breath.dayTime" trigger="click">
										<a-time-picker v-if="norShowChange.breath.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.day.timeLow" @change="breathDayTimeLowChange" />&nbsp;
										<a-time-picker v-if="norShowChange.breath.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.day.timeUp" @change="breathDayTimeUpChange" /><br><br>
										<a-button type="primary" @click="breathDayTimeConfirm">确定</a-button>
									</el-popover>
								</div>
								<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.realTimeMon }" @click="breathDayReset">重置为初始默认值</div>
							</div>
							
							
							<div class="fsm-card-table-row-item_2" style="padding-left: 0px;">
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px; border-left: unset;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.breath.night.bpmLow }}~{{ thrsNormal.breath.night.bpmUp }}&nbsp;BPM&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.breath.nightBpm = !norShowChange.breath.nightBpm" style="margin-right: 0px;" />
									<el-popover v-model="norShowChange.breath.nightBpm" trigger="click">
										<a-input-number v-if="norShowChange.breath.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.night.bpmLow" @change="breathNightBpmLowChange" />&nbsp;
										<a-input-number v-if="norShowChange.breath.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.night.bpmUp" @change="breathNightBpmUpChange" /><br><br>
										<a-button type="primary" @click="breathNightBpmConfirm">确定</a-button>
									</el-popover>&emsp;
								</div>
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.breath.night.timeLow }}~{{ thrsNormal.breath.night.timeUp }}&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.breath.nightTime = !norShowChange.breath.nightTime" />
									<el-popover v-model="norShowChange.breath.nightTime" trigger="click">
										<a-time-picker v-if="norShowChange.breath.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.night.timeLow" @change="breathNightTimeLowChange" />&nbsp;
										<a-time-picker v-if="norShowChange.breath.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.night.timeUp" @change="breathNightTimeUpChange" /><br><br>
										<a-button type="primary" @click="breathNightTimeConfirm">确定</a-button>
									</el-popover>
								</div>
								<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.realTimeMon }" @click="breathNightReset">重置为初始默认值</div>
							</div>
						</div>
					</div>
					<!-- 心跳正常阈值 -->
					<div class="fsm-card-table-row">
						<div class="fsm-card-table-row-item_1" style="height: 80px;">
							<span class="fsm-card-table-row-text_1" :class="{ text_color_ff4d4f: conflictValues.fall }">心跳正常阈值</span>
						</div>
						<div style="display: flex; flex-direction: column;">
							<div class="fsm-card-table-row-item_2" style="padding-left: 0px;">
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px; border-left: unset;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.heart.day.bpmLow }}~{{ thrsNormal.heart.day.bpmUp }}&nbsp;BPM&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.heart.dayBpm = !norShowChange.heart.dayBpm" style="margin-right: 0px;" />
									<el-popover v-model="norShowChange.heart.dayBpm" trigger="click">
										<a-input-number v-if="norShowChange.heart.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.day.bpmLow" @change="heartDayBpmLowChange" />&nbsp;
										<a-input-number v-if="norShowChange.heart.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.day.bpmUp" @change="heartDayBpmUpChange" /><br><br>
										<a-button type="primary" @click="heartDayBpmConfirm">确定</a-button>
									</el-popover>&emsp;
								</div>
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.heart.day.timeLow }}~{{ thrsNormal.heart.day.timeUp }}&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.heart.dayTime = !norShowChange.heart.dayTime" />
									<el-popover v-model="norShowChange.heart.dayTime" trigger="click">
										<a-time-picker v-if="norShowChange.heart.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.day.timeLow" @change="heartDayTimeLowChange" />&nbsp;
										<a-time-picker v-if="norShowChange.heart.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.day.timeUp" @change="heartDayTimeUpChange" /><br><br>
										<a-button type="primary" @click="heartDayTimeConfirm">确定</a-button>
									</el-popover>
								</div>
								<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.realTimeMon }" @click="heartDayReset">重置为初始默认值</div>
							</div>
							
							
							<div class="fsm-card-table-row-item_2" style="padding-left: 0px;">
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px; border-left: unset;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.heart.night.bpmLow }}~{{ thrsNormal.heart.night.bpmUp }}&nbsp;BPM&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.heart.nightBpm = !norShowChange.heart.nightBpm" style="margin-right: 0px;" />
									<el-popover v-model="norShowChange.heart.nightBpm" trigger="click">
										<a-input-number v-if="norShowChange.heart.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.night.bpmLow" @change="heartNightBpmLowChange" />&nbsp;
										<a-input-number v-if="norShowChange.heart.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.night.bpmUp" @change="heartNightBpmUpChange" /><br><br>
										<a-button type="primary" @click="heartNightBpmConfirm">确定</a-button>
									</el-popover>&emsp;
								</div>
								<div class="fsm-card-table-row-edit" style="width: 208px; margin-left: 0px;">
									<div class="fsm-card-table-row-edit-left">
										<span :class="switchCheck.realTimeMon ? 'fsm-card-table-row-text_1' : 'fsm-card-table-row-text_1_disabled'">{{ thrsNormal.heart.night.timeLow }}~{{ thrsNormal.heart.night.timeUp }}&nbsp;</span>
									</div>
									<a-icon type="form" :class="switchCheck.realTimeMon ? 'fsm-card-table-row-edit-right' : 'fsm-card-table-row-edit-right_disabled'" @click="norShowChange.heart.nightTime = !norShowChange.heart.nightTime" />
									<el-popover v-model="norShowChange.heart.nightTime" trigger="click">
										<a-time-picker v-if="norShowChange.heart.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.night.timeLow" @change="heartNightTimeLowChange" />&nbsp;
										<a-time-picker v-if="norShowChange.heart.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.night.timeUp" @change="heartNightTimeUpChange" /><br><br>
										<a-button type="primary" @click="heartNightTimeConfirm">确定</a-button>
									</el-popover>
								</div>
								<div class="fsm-card-table-row-reset_btn" :class=" { 'fsm-card-table-row-reset_btn_disabled': !switchCheck.realTimeMon }" @click="heartNightReset">重置为初始默认值</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- -------- -->
			<div class="fsm-card" style="padding-bottom: 16px;">
				<div class="fsm-card-header">
					<div class="fsm-card-header-border"></div>
					<span class="fsm-card-header-title">其他</span>
				</div>
				<div class="fsm-card-table fsm-card-border_right fsm-card-border_bottom">
					<span class="fsm-card-table-header">
						健康报告
						<span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.healthReport" @change="healthReportSwitch" />
						</span>
					</span>
					<span class="fsm-card-table-header" style="background: #FAFAFA;">
						4G套餐续费入口
						 <span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.fourG_check" @change="fourG_checkSwitch" />
						</span>
					</span>
				</div>
			</div>

			<div class="fsm-header" style="margin-top: 20px;">
				<div class="fsm-header-dot"></div>
				<span class="fsm-header-title">护理辅助</span>
			</div>

			<div class="fsm-card" style="padding-top: 8px; padding-bottom: 16px;">
				<div class="fsm-card-table fsm-card-border_right fsm-card-border_bottom">
					<span class="fsm-card-table-header">
						查看健康报告
						<span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.healthReportCheck" @change="healthReportCheckSwitch" />
						</span>
					</span>
					<span class="fsm-card-table-header" style="background: #FAFAFA;">
						查看/修改老人信息
						<span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.checkInfo" @change="checkInfoSwitch" />
						</span>
					</span>
				</div>
			</div>

			<div class="fsm-header" style="margin-top: 20px;">
				<div class="fsm-header-dot"></div>
				<span class="fsm-header-title">健康大数据</span>
			</div>

			<div class="fsm-card" style="padding-top: 8px; padding-bottom: 16px; margin-bottom: 24px;">
				<div class="fsm-card-table fsm-card-border_right fsm-card-border_bottom">
					<span class="fsm-card-table-header">
						老人健康数据
						 <span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.healthInfo" @change="healthInfoSwitch" />
						</span>
					</span>
					<span class="fsm-card-table-header" style="background: #FAFAFA;">
						员工工效数据
						<span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.workEffi" @change="workEffiSwitch" />
						</span>
					</span>
					<span class="fsm-card-table-header">
						设备运营数据
						<span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.opeData" @change="opeDataSwitch" />
						</span>
					</span>
					<span class="fsm-card-table-header" style="background: #FAFAFA;">
						实时设备运行
						 <span style="position: relative; left: 15px;">
							<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.realTimeOpe" @change="realTimeOpeSwitch" />
						</span>
					</span>
				</div>
			</div>




      <div v-if="false" class="ftitles">整体功能模块</div><br>
      <table v-if="false" border="1" align="center" width="100%" bordercolor="#f0f0f0">
        <tr style="background-color: #F0F0F0;">
          <td colspan="4">
            <span class="tableContent" style="left: -360px;">
              生命体征监测
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <span class="tableContent" style="left: -335px;">
              <span class="calDot"></span>生命体征报警类别
            </span>
          </td>
        </tr>
        <tr>
          <td style="background-color: #F0F0F0; width: 20%">类别</td>
          <td style="width: 20%;"></td>
          <td style="background-color: #F0F0F0; width: 20%">报警阈值</td>
          <td style="width: 40%"></td>
        </tr>
        <!-- <tr>
					<td style="width: 20%; border-right: #ffffff">离床过久</td>
					<td style="width: 20%; border-left: #ffffff">
						<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.outBed" @change="outBedSwitch"/>
					</td>
					<td colspan="2" class="thrsList" v-if="switchCheck.outBed">
						<span v-if="!outBedThrsShow">{{ thrs.outBed }}&nbsp;&nbsp;</span>
						<a-time-picker v-if="outBedThrsShow" size="small" format="HH:mm:ss" :defaultValue="thrsDefaultTime.outBed" @change="outBedThrsChange" />&nbsp;
						<a-button v-if="outBedThrsShow" size="small" type="primary" @click="outBedThrsConfirm">确定</a-button>
						<a-icon v-if="!outBedThrsShow" type="form" class="tableIcon" @click="outBedThrsShow = !outBedThrsShow; setDefaultThrsTime()"/>
						<div class="bedItem" @click="outBedReset">重置为初始默认值</div>
					</td>
					<td colspan="2" class="thrsList" v-else>
						<span style="color: #b7b7b7; cursor: not-allowed">{{ thrs.outBed }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a-icon type="form" class="tableIconDisabled" @click=""/>
						<div class="bedItemDisabled">重置为初始默认值</div>
					</td>
				</tr> -->
        <!-- <tr>
					<td style="width: 20%; border-right: #ffffff">跌倒</td>
					<td style="width: 20%; border-left: #ffffff">
						<a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.fall" @change="fallSwitch"/>
					</td>
					<td colspan="2" class="thrsList" v-if="switchCheck.fall">
						<span v-if="!fallThrsShow">{{ thrs.fall }}&nbsp;&nbsp;</span>
						<a-time-picker v-if="fallThrsShow" size="small" format="HH:mm:ss" :defaultValue="thrsDefaultTime.fall" @change="fallThrsChange" />&nbsp;
						<a-button v-if="fallThrsShow" size="small" type="primary" @click="fallThrsConfirm">确定</a-button>
						<a-icon v-if="!fallThrsShow" type="form" class="tableIcon" @click="fallThrsShow = !fallThrsShow; setDefaultThrsTime()"/>
						<div class="bedItem" @click="fallReset">重置为初始默认值</div>
					</td>
					<td colspan="2" class="thrsList" v-else>
						<span style="color: #b7b7b7; cursor: not-allowed">{{ thrs.fall }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a-icon type="form" class="tableIconDisabled" @click=""/>
						<div class="bedItemDisabled">重置为初始默认值</div>
					</td>
				</tr> -->
        <tr>
          <td style="width: 20%; border-right: #ffffff;" v-if="!conflictValues.fall">跌倒</td>
          <td style="width: 20%; border-right: #ffffff; color: #ff4d4f" v-else>跌倒</td>
          <td style="width: 20%; border-left: #ffffff">
            <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.fall" @change="fallSwitch" />
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.fall">
            <span v-if="!breathThrsShow">电话报警&nbsp;&nbsp;</span>
             <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.phoneAlarm" @change="phoneAlarmSwitch" />
            <div class="bedItem" @click="alarmFallReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span>电话报警&nbsp;&nbsp;</span>
            <a-switch checked-children="开" un-checked-children="关" :disabled="true" :checked="switchCheck.phoneAlarm" @change="phoneAlarmSwitch" />
            <div class="bedItemDisabled">重置为初始默认值</div>
          </td>
        </tr>
         <tr>
          <td style="width: 20%; border-right: #ffffff;" v-if="!conflictValues.toitet">卫生间停留过久</td>
          <td style="width: 20%; border-right: #ffffff; color: #ff4d4f" v-else>卫生间停留过久</td>
          <td style="width: 20%; border-left: #ffffff">
            <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.toitet" @change="toitetFallSwitch" />
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.toitet">
            <span v-if="!breathThrsShow">电话报警&nbsp;&nbsp;</span>
             <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.toitetPhoneAlarm" @change="toitetPhoneAlarmSwitch" />
            <div class="bedItem" @click="toitetAlarmFallReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span>电话报警&nbsp;&nbsp;</span>
            <a-switch checked-children="开" un-checked-children="关" :disabled="true" :checked="switchCheck.toitetPhoneAlarm" @change="toitetPhoneAlarmSwitch" />
            <div class="bedItemDisabled">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td style="width: 20%; border-right: #ffffff;" v-if="!conflictValues.breath">呼吸过速</td>
          <td style="width: 20%; border-right: #ffffff; color: #ff4d4f" v-else>呼吸过速</td>
          <td style="width: 20%; border-left: #ffffff">
            <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.breath" @change="breathSwitch" />
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.breath">
            <span v-if="!breathThrsShow">{{ thrs.breathBpm }}BPM&emsp;{{ thrs.breath }}&nbsp;&nbsp;</span>
            <a-input-number v-if="breathThrsShow" :min="27" :max="40" :step="1" size="small" :defaultValue="thrs.breathBpm" @change="breathBpmChange" />&nbsp;
            <a-time-picker v-if="breathThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.breath" @change="breathThrsChange" />&nbsp;
            <a-button v-if="breathThrsShow" size="small" type="primary" @click="breathThrsConfirm">确定</a-button>
            <a-icon v-if="!breathThrsShow" type="form" class="tableIcon" @click="breathThrsShow = !breathThrsShow; setDefaultThrsTime()" />
            <div class="bedItem" @click="breathReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrs.breathBpm }}BPM&emsp;{{ thrs.breath }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td style="width: 20%; border-right: #ffffff">呼吸暂停过久</td>
          <td style="width: 20%; border-left: #ffffff">
            <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.apnea" @change="apneaSwitch" />
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.apnea">
            <span v-if="!apneaThrsShow">{{ thrs.apneaMm }}m&emsp;{{ thrs.apnea }}&nbsp;&nbsp;</span>
            <a-input-number v-if="apneaThrsShow" :min="0" :step="0.0001" size="small" :defaultValue="thrs.apneaMm" @change="apneaMmChange" />&nbsp;
            <a-time-picker v-if="apneaThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.apnea" @change="apneaThrsChange" />&nbsp;
            <a-button v-if="apneaThrsShow" size="small" type="primary" @click="apneaThrsConfirm">确定</a-button>
            <a-icon v-if="!apneaThrsShow" type="form" class="tableIcon" @click="apneaThrsShow = !apneaThrsShow; setDefaultThrsTime()" />
            <div class="bedItem" @click="apneaReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrs.apneaMm }}mm&emsp;{{ thrs.apnea }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td style="width: 20%; border-right: #ffffff;" v-if="!conflictValues.heart">心跳过速</td>
          <td style="width: 20%; border-right: #ffffff; color: #ff4d4f" v-else>心跳过速</td>
          <td style="width: 20%; border-left: #ffffff">
            <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.heart" @change="heartSwitch" />
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.heart">
            <span v-if="!heartThrsShow">{{ thrs.heartBpm }}BPM&emsp;{{ thrs.heart }}&nbsp;&nbsp;</span>
            <a-input-number v-if="heartThrsShow" :min="0" :step="1" size="small" :defaultValue="thrs.heartBpm" @change="heartBpmChange" />&nbsp;
            <a-time-picker v-if="heartThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.heart" @change="heartThrsChange" />&nbsp;
            <a-button v-if="heartThrsShow" size="small" type="primary" @click="heartThrsConfirm">确定</a-button>
            <a-icon v-if="!heartThrsShow" type="form" class="tableIcon" @click="heartThrsShow = !heartThrsShow; setDefaultThrsTime()" />
            <div class="bedItem" @click="heartReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrs.heartBpm }}BPM&emsp;{{ thrs.heart }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td style="width: 20%; border-right: #ffffff" v-if="!conflictValues.heartBra">心跳过缓</td>
          <td style="width: 20%; border-right: #ffffff; color: #ff4d4f" v-else>心跳过缓</td>
          <td style="width: 20%; border-left: #ffffff">
            <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.heartBra" @change="heartBraSwitch" />
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.heartBra">
            <span v-if="!heartBraThrsShow">{{ thrs.heartBraBpm }}BPM&emsp;{{ thrs.heartBra }}&nbsp;&nbsp;</span>
            <a-input-number v-if="heartBraThrsShow" :min="0" :step="1" size="small" :defaultValue="thrs.heartBraBpm" @change="heartBraBpmChange" />&nbsp;
            <a-time-picker v-if="heartBraThrsShow" format="HH:mm:ss" size="small" :defaultValue="thrsDefaultTime.heartBra" @change="heartBraThrsChange" />&nbsp;
            <a-button v-if="heartBraThrsShow" size="small" type="primary" @click="heartBraThrsConfirm">确定</a-button>
            <a-icon v-if="!heartBraThrsShow" type="form" class="tableIcon" @click="heartBraThrsShow = !heartBraThrsShow; setDefaultThrsTime()" />
            <div class="bedItem" @click="heartBraReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrs.heartBraBpm }}BPM&emsp;{{ thrs.heartBra }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td style="width: 20%; border-right: #ffffff"><span class="calDot"></span>实时监测正常反馈</td>
          <td style="width: 20%; border-left: #ffffff">
            <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.realTimeMon" @change="realTimeSwitch" />
          </td>
          <td colspan="2">
          </td>
        </tr>
        <tr>
          <td style="background-color: #F0F0F0; width: 20%">类别</td>
          <td style="width: 20%;"></td>
          <td style="background-color: #F0F0F0; width: 20%">设定阈值</td>
          <td style="width: 40%"></td>
        </tr>
        <tr>
          <td style="width: 20%; border-right: #ffffff" rowspan="2" v-if="!conflictValues.breathThrs"></span>呼吸正常阈值</td>
          <td style="width: 20%; border-right: #ffffff; color: #ff4d4f;" rowspan="2" v-else></span>呼吸正常阈值</td>
          <td style="width: 20%; border-left: #ffffff" rowspan="2">
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.realTimeMon">
            <span>{{ thrsNormal.breath.day.bpmLow }}~{{ thrsNormal.breath.day.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.breath.dayBpm = !norShowChange.breath.dayBpm" />
            <el-popover v-model="norShowChange.breath.dayBpm" trigger="click">
              <a-input-number v-if="norShowChange.breath.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.day.bpmLow" @change="breathDayBpmLowChange" />&nbsp;
              <a-input-number v-if="norShowChange.breath.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.day.bpmUp" @change="breathDayBpmUpChange" /><br><br>
              <a-button type="primary" @click="breathDayBpmConfirm">确定</a-button>
            </el-popover>&emsp;

            <span>{{ thrsNormal.breath.day.timeLow }}~{{ thrsNormal.breath.day.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.breath.dayTime = !norShowChange.breath.dayTime" />
            <el-popover v-model="norShowChange.breath.dayTime" trigger="click">
              <a-time-picker v-if="norShowChange.breath.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.day.timeLow" @change="breathDayTimeLowChange" />&nbsp;
              <a-time-picker v-if="norShowChange.breath.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.day.timeUp" @change="breathDayTimeUpChange" /><br><br>
              <a-button type="primary" @click="breathDayTimeConfirm">确定</a-button>
            </el-popover>
            <div class="bedItem" @click="breathDayReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.breath.day.bpmLow }}~{{ thrsNormal.breath.day.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />&emsp;
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.breath.day.timeLow }}~{{ thrsNormal.breath.day.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled" @click="breathDayReset">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="thrsList" v-if="switchCheck.realTimeMon">
            <span>{{ thrsNormal.breath.night.bpmLow }}~{{ thrsNormal.breath.night.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.breath.nightBpm = !norShowChange.breath.nightBpm" />
            <el-popover v-model="norShowChange.breath.nightBpm" trigger="click">
              <a-input-number v-if="norShowChange.breath.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.night.bpmLow" @change="breathNightBpmLowChange" />&nbsp;
              <a-input-number v-if="norShowChange.breath.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.breath.night.bpmUp" @change="breathNightBpmUpChange" /><br><br>
              <a-button type="primary" @click="breathNightBpmConfirm">确定</a-button>
            </el-popover>&emsp;

            <span>{{ thrsNormal.breath.night.timeLow }}~{{ thrsNormal.breath.night.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.breath.nightTime = !norShowChange.breath.nightTime" />
            <el-popover v-model="norShowChange.breath.nightTime" trigger="click">
              <a-time-picker v-if="norShowChange.breath.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.night.timeLow" @change="breathNightTimeLowChange" />&nbsp;
              <a-time-picker v-if="norShowChange.breath.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.breath.night.timeUp" @change="breathNightTimeUpChange" /><br><br>
              <a-button type="primary" @click="breathNightTimeConfirm">确定</a-button>
            </el-popover>
            <div class="bedItem" @click="breathNightReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.breath.night.bpmLow }}~{{ thrsNormal.breath.night.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />&emsp;
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.breath.night.timeLow }}~{{ thrsNormal.breath.night.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled" @click="breathDayReset">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td style="width: 20%; border-right: #ffffff" rowspan="2" v-if="!conflictValues.heartThrs"></span>心跳正常阈值</td>
          <td style="width: 20%; border-right: #ffffff; color: #ff4d4f;" rowspan="2" v-else></span>心跳正常阈值</td>
          <td style="width: 20%; border-left: #ffffff" rowspan="2">
          </td>
          <td colspan="2" class="thrsList" v-if="switchCheck.realTimeMon">
            <span>{{ thrsNormal.heart.day.bpmLow }}~{{ thrsNormal.heart.day.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.heart.dayBpm = !norShowChange.heart.dayBpm" />
            <el-popover v-model="norShowChange.heart.dayBpm" trigger="click">
              <a-input-number v-if="norShowChange.heart.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.day.bpmLow" @change="heartDayBpmLowChange" />&nbsp;
              <a-input-number v-if="norShowChange.heart.dayBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.day.bpmUp" @change="heartDayBpmUpChange" /><br><br>
              <a-button type="primary" @click="heartDayBpmConfirm">确定</a-button>
            </el-popover>&emsp;

            <span>{{ thrsNormal.heart.day.timeLow }}~{{ thrsNormal.heart.day.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.heart.dayTime = !norShowChange.heart.dayTime" />
            <el-popover v-model="norShowChange.heart.dayTime" trigger="click">
              <a-time-picker v-if="norShowChange.heart.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.day.timeLow" @change="heartDayTimeLowChange" />&nbsp;
              <a-time-picker v-if="norShowChange.heart.dayTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.day.timeUp" @change="heartDayTimeUpChange" /><br><br>
              <a-button type="primary" @click="heartDayTimeConfirm">确定</a-button>
            </el-popover>
            <div class="bedItem" @click="heartDayReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.heart.day.bpmLow }}~{{ thrsNormal.heart.day.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />&emsp;
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.heart.day.timeLow }}~{{ thrsNormal.heart.day.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled" @click="breathDayReset">重置为初始默认值</div>
          </td>
        </tr>
        <tr>
          <td colspan="2" class="thrsList" v-if="switchCheck.realTimeMon">
            <span>{{ thrsNormal.heart.night.bpmLow }}~{{ thrsNormal.heart.night.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.heart.nightBpm = !norShowChange.heart.nightBpm" />
            <el-popover v-model="norShowChange.heart.nightBpm" trigger="click">
              <a-input-number v-if="norShowChange.heart.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.night.bpmLow" @change="heartNightBpmLowChange" />&nbsp;
              <a-input-number v-if="norShowChange.heart.nightBpm" :min="0" :step="1" size="small" :defaultValue="thrsNormal.heart.night.bpmUp" @change="heartNightBpmUpChange" /><br><br>
              <a-button type="primary" @click="heartNightBpmConfirm">确定</a-button>
            </el-popover>&emsp;

            <span>{{ thrsNormal.heart.night.timeLow }}~{{ thrsNormal.heart.night.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIcon" @click="norShowChange.heart.nightTime = !norShowChange.heart.nightTime" />
            <el-popover v-model="norShowChange.heart.nightTime" trigger="click">
              <a-time-picker v-if="norShowChange.heart.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.night.timeLow" @change="heartNightTimeLowChange" />&nbsp;
              <a-time-picker v-if="norShowChange.heart.nightTime" format="HH:mm" size="small" :defaultValue="thrsNormalDefaultTime.heart.night.timeUp" @change="heartNightTimeUpChange" /><br><br>
              <a-button type="primary" @click="heartNightTimeConfirm">确定</a-button>
            </el-popover>
            <div class="bedItem" @click="heartNightReset">重置为初始默认值</div>
          </td>
          <td colspan="2" class="thrsList" v-else>
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.heart.night.bpmLow }}~{{ thrsNormal.heart.night.bpmUp }}&nbsp;BPM&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />&emsp;
            <span style="color: #b7b7b7; cursor: not-allowed">{{ thrsNormal.heart.night.timeLow }}~{{ thrsNormal.heart.night.timeUp }}&nbsp;</span>
            <a-icon type="form" class="tableIconDisabled" @click="" />
            <div class="bedItemDisabled" @click="breathDayReset">重置为初始默认值</div>
          </td>
        </tr>
        <tr style="background-color: #F0F0F0;">
          <td colspan="4">
            <span class="tableContent" style="left: -350px;">
              健康报告
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.healthReport" @change="healthReportSwitch" />
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <span class="tableContent" style="left: -326px;">
              4G套餐续费入口
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.fourG_check" @change="fourG_checkSwitch" />
              </span>
            </span>
          </td>
        </tr>
      </table><br>
      <div v-if="false" class="ftitles">护理辅助</div><br>
      <table v-if="false" border="1" align="center" width="100%" bordercolor="#f0f0f0">
        <tr>
          <td colspan="4">
            <span class="tableContent" style="left: -340px;">
              查看健康报告
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.healthReportCheck" @change="healthReportCheckSwitch" />
              </span>
            </span>
          </td>
        </tr>
        <tr style="background-color: #F0F0F0;">
          <td colspan="4">
            <span class="tableContent" style="left: -324px;">
              查看/修改老人信息
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.checkInfo" @change="checkInfoSwitch" />
              </span>
            </span>
          </td>
        </tr>
      </table><br>
      <div v-if="false" class="ftitles">健康大数据</div><br>
      <table v-if="false" border="1" align="center" width="100%" bordercolor="#f0f0f0">
        <tr>
          <td colspan="4">
            <span class="tableContent" style="left: -340px;">
              老人健康数据
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.healthInfo" @change="healthInfoSwitch" />
              </span>
            </span>
          </td>
        </tr>
        <tr style="background-color: #F0F0F0;">
          <td colspan="4">
            <span class="tableContent" style="left: -340px;">
              员工工效数据
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.workEffi" @change="workEffiSwitch" />
              </span>
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="4">
            <span class="tableContent" style="left: -340px;">
              设备运营数据
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.opeData" @change="opeDataSwitch" />
              </span>
            </span>
          </td>
        </tr>
        <tr style="background-color: #F0F0F0;">
          <td colspan="4">
            <span class="tableContent" style="left: -340px;">
              实时设备运行
              <span style="position: relative; left: 15px;">
                <a-switch checked-children="开" un-checked-children="关" :checked="switchCheck.realTimeOpe" @change="realTimeOpeSwitch" />
              </span>
            </span>
          </td>
        </tr>
      </table><br>
    </a-modal>
  </div>
</template>

<script>
import Global from "../../utils/global";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
const columns = [
  {
    title: "机构名称",
    key: "name",
    width: "14%",
    align: "center",
    scopedSlots: { customRender: "scopedName" },
  },
  {
    title: "机构网址",
    key: "siteUrl",
    width: "14%",
    align: "center",
    scopedSlots: { customRender: "website" },
  },
  {
    title: "监测仪总数",
    key: "deviceCnt",
    width: "9%",
    align: "center",
    scopedSlots: { customRender: "deviceCnt" },
  },
  {
    title: "已绑定总数",
    key: "boundCnt",
    dataIndex: "boundCnt",
    width: "9%",
    align: "center",
  },
  {
    title: "工作中",
    key: "workingCnt",
    dataIndex: "workingCnt",
    width: "9%",
    align: "center",
  },
  {
    title: "离线",
    key: "offlineCnt",
    dataIndex: "offlineCnt",
    width: "9%",
    align: "center",
  },
  {
    title: "人员总数",
    key: "userCnt",
    dataIndex: "userCnt",
    width: "9%",
    align: "center",
  },
  {
    title: "机构管理员",
    key: "eventProcTime",
    width: "9%",
    align: "center",
    scopedSlots: { customRender: "mechanism" },
  },
  {
    title: "操作",
    align: "center",
    key: "operation",
    width: "18%",
    scopedSlots: { customRender: "operation" },
  },
];
const columns1 = [
  {
    title: "机构名称",
    key: "name",
    width: "15%",
    align: "center",
    scopedSlots: { customRender: "scopedName" },
  },
  {
    title: "监测仪sn码",
    key: "deviceSn",
    width: "15%",
    align: "center",
    scopedSlots: { customRender: "deviceSn" },
  },
  {
    title: "监测床位",
    key: "deviceBed",
    // width: "390px",
    align: "center",
    scopedSlots: { customRender: "deviceBed" },
  },
  {
    title: "机构管理员",
    key: "eventProcTime",
    width: "15%",
    align: "center",
    scopedSlots: { customRender: "mechanism" },
  },
  {
    title: "操作",
    align: "center",
    key: "operation",
    width: "18%",
    scopedSlots: { customRender: "operation" },
  },
];
export default {
  data() {
    return {
      searchVal: "", // 搜索绑定值
	  searchVal2: "", // 搜索绑定值
      columns,
	  columns1,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 20,
      addMechanismPopup: false, // 机构弹窗
      adminUserPopup: false, // 机构管理员
      replaceThemePopup: false, // 更换主题
      previewVisible: false, // 图片预览
      previewImage: "", // 预览图片Url
      nameTips: "机构名称只支持字母、数字或汉字，最多可输入20个字符",
      nameColor: "#BFBFBF", // 提示默认字体颜色
      nameIcon: false,
      webColor: "#BFBFBF",
      webTips: "非必填",
      webIcon: false,
      loading: false,
      addListData: {
        name: "",
        website: "",
      },
      typeNum: "",
      typeId: "",
      adminUserType: "",
      adminNameTips: "姓名只支持字母、数字或汉字，最多可输入20个字符",
      passwordIcon: false, // 密码警告状态
      phoneIcon: false, // 手机号警告状态
      phoneColor: "#BFBFBF", // 提示默认字体颜色
      passwordColor: "#BFBFBF", // 提示默认字体颜色
      passwordTips: "",
      phoneTips: "", // 手机号填写提示
      adminUserList: {
        name: "",
        phone: "",
        password: "",
      },
      scope: "", // 编辑数据
      searchType: 0, // 搜索状态 0-未搜索 1-机构名称搜索 2-SN搜索
      fileList: [],
      headers: {
        Authentication: this.$getCookie("userInfo").token,
      },
      bannerUrl: "", // 主题图片地址
      tenantId: "", // 机构id
      colorHide: false,
      backGroundColor: "",
      colorListData: [
        "linear-gradient(270deg, #C3E2FF 0%, #FFFFFF 37%, #FFFFFF 100%)",
        "linear-gradient(to left, #2DC1FF, #1890FF)",
        "linear-gradient(to left, #A9E275, #5CC726)",
        "linear-gradient(to left, #FFAB5C, #FF8318)",
        "linear-gradient(to left, #FA7700, #C80000)",
        "linear-gradient(270deg, #7A7A7A 0%, #333333 100%)",
        "linear-gradient(270deg, #B080FF 0%, #5A15E5 100%)",
      ],
      functionVisible: false,
      activeTenantId: null,
      alarmData: [],
      monitoringData: [],
      healthBigData: [],
      thrs: {
        outBed: null,
        fall: null,
        toitet: null,
        breath: null,
        breathBpm: null,
        apnea: null,
        apneaMm: null,
        heart: null,
        heartBpm: null,
        heartBra: null,
        heartBraBpm: null,
      },
      thrsDefault: {
        outBed: "00:00:45",
        fall: "00:00:10",
        breath: "00:00:45",
        breathBpm: "27",
        apnea: "00:00:45",
        apneaMm: "0.0007",
        heart: "00:00:45",
        heartBpm: "100",
        heartBra: "00:00:45",
        heartBraBpm: "40",
      },
      thrsTemp: {
        outBed: null,
        fall: null,
        breath: null,
        breathBpm: null,
        apnea: null,
        apneaMm: null,
        heart: null,
        heartBpm: null,
        heartBra: null,
        heartBraBpm: null,
      },
      outBedThrsShow: false,
      fallThrsShow: false,
      breathThrsShow: false,
      apneaThrsShow: false,
      heartThrsShow: false,
      heartBraThrsShow: false,
      thrsDefaultTime: {
        outBed: null,
        fall: null,
        breath: null,
        apnea: null,
        heart: null,
        heartBra: null,
      },
      thrsNormal: {
        breath: {
          day: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
          night: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
        },
        heart: {
          day: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
          night: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
        },
      },
      thrsNormalDefault: {
        breath: {
          day: {
            bpmLow: "12",
            bpmUp: "20",
            timeLow: "08:01",
            timeUp: "19:59",
          },
          night: {
            bpmLow: "8",
            bpmUp: "24",
            timeLow: "20:00",
            timeUp: "08:00",
          },
        },
        heart: {
          day: {
            bpmLow: "60",
            bpmUp: "100",
            timeLow: "08:01",
            timeUp: "19:59",
          },
          night: {
            bpmLow: "40",
            bpmUp: "90",
            timeLow: "20:00",
            timeUp: "08:00",
          },
        },
      },
      thrsNormalTemp: {
        breath: {
          day: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
          night: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
        },
        heart: {
          day: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
          night: {
            bpmLow: null,
            bpmUp: null,
            timeLow: null,
            timeUp: null,
          },
        },
      },
      norShowChange: {
        breath: {
          dayBpm: false,
          dayTime: false,
          nightBpm: false,
          nightTime: false,
        },
        heart: {
          dayBpm: false,
          dayTime: false,
          nightBpm: false,
          nightTime: false,
        },
      },
      thrsNormalDefaultTime: {
        breath: {
          day: {
            timeLow: null,
            timeUp: null,
          },
          night: {
            timeLow: null,
            timeUp: null,
          },
        },
        heart: {
          day: {
            timeLow: null,
            timeUp: null,
          },
          night: {
            timeLow: null,
            timeUp: null,
          },
        },
      },
      switchCheck: {
        toitet:true,
        toitetPhoneAlarm:true,
        phoneAlarm:true,
        outBed: true,
        fall: true,
        breath: true,
				breathPhoneAlarm: true,
        apnea: true,
				apneaPhoneAlarm: true,
        heart: true,
				heartPhoneAlarm: true,
        heartBra: true,
				heartBraPhoneAlarm: true,
        realTimeMon: true,
        healthReport: true,
        healthReportCheck: true,
        checkInfo: true,
        healthInfo: true,
        workEffi: true,
        opeData: true,
        realTimeOpe: true,
      },
      activeAlarmData: [],
      activeMonitoringData: [],
      activeHealthBigData: [],
      activeTitle: "",
      conflictValues: {
        toitet: false,
        fall: false,
        breath: false,
        heart: false,
        heartBra: false,
        breathThrs: false,
        heartThrs: false,
      },
    };
  },
  mounted() {
    this.getTableData();

    // this.setMonitoringData();
  },
  methods: {
    setDefaultThrs() {
      var td = JSON.stringify(this.thrsDefault);
      this.thrs = JSON.parse(td);
      var tnd = JSON.stringify(this.thrsNormalDefault);
      this.thrsNormal = JSON.parse(tnd);
    },
    setDefaultThrsTime() {
      if (this.thrs.outBed != null) {
        this.thrsDefaultTime.outBed = this.$moment(
          this.thrs.outBed,
          "hh:mm:ss"
        );
        this.thrsTemp.outBed = this.thrs.outBed;
      } else {
        this.thrsDefaultTime.outBed = this.$moment(
          this.thrsDefault.outBed,
          "hh:mm:ss"
        );
        this.thrsTemp.outBed = this.thrsDefault.outBed;
      }
      if (this.thrs.fall != null) {
        this.thrsDefaultTime.fall = this.$moment(this.thrs.fall, "hh:mm:ss");
        this.thrsTemp.fall = this.thrs.fall;
      } else {
        this.thrsDefaultTime.fall = this.$moment(
          this.thrsDefault.fall,
          "hh:mm:ss"
        );
        this.thrsTemp.fall = this.thrsDefault.fall;
      }
      if (this.thrs.breath != null) {
        this.thrsDefaultTime.breath = this.$moment(
          this.thrs.breath,
          "hh:mm:ss"
        );
        this.thrsTemp.breath = this.thrs.breath;
      } else {
        this.thrsDefaultTime.breath = this.$moment(
          this.thrsDefault.breath,
          "hh:mm:ss"
        );
        this.thrsTemp.breath = this.thrsDefault.breath;
      }
      if (this.thrs.apnea != null) {
        this.thrsDefaultTime.apnea = this.$moment(this.thrs.apnea, "hh:mm:ss");
        this.thrsTemp.apnea = this.thrs.apnea;
      } else {
        this.thrsDefaultTime.apnea = this.$moment(
          this.thrsDefault.apnea,
          "hh:mm:ss"
        );
        this.thrsTemp.apnea = this.thrsDefault.apnea;
      }
      if (this.thrs.heart != null) {
        this.thrsDefaultTime.heart = this.$moment(this.thrs.heart, "hh:mm:ss");
        this.thrsTemp.heart = this.thrs.heart;
      } else {
        this.thrsDefaultTime.heart = this.$moment(
          this.thrsDefault.heart,
          "hh:mm:ss"
        );
        this.thrsTemp.heart = this.thrsDefault.heart;
      }
      if (this.thrs.heartBra != null) {
        this.thrsDefaultTime.heartBra = this.$moment(
          this.thrs.heartBra,
          "hh:mm:ss"
        );
        this.thrsTemp.heartBra = this.thrs.heartBra;
      } else {
        this.thrsDefaultTime.heartBra = this.$moment(
          this.thrsDefault.heartBra,
          "hh:mm:ss"
        );
        this.thrsTemp.heartBra = this.thrsDefault.heartBra;
      }
      if (this.thrsNormal.breath.day.timeLow != null) {
        this.thrsNormalDefaultTime.breath.day.timeLow = this.$moment(
          this.thrsNormal.breath.day.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.day.timeLow =
          this.thrsNormal.breath.day.timeLow;
      } else {
        this.thrsNormalDefaultTime.breath.day.timeLow = this.$moment(
          this.thrsNormalDefault.breath.day.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.day.timeLow =
          this.thrsNormalDefault.breath.day.timeLow;
      }
      if (this.thrsNormal.breath.day.timeUp != null) {
        this.thrsNormalDefaultTime.breath.day.timeUp = this.$moment(
          this.thrsNormal.breath.day.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.day.timeUp =
          this.thrsNormal.breath.day.timeUp;
      } else {
        this.thrsNormalDefaultTime.breath.day.timeUp = this.$moment(
          this.thrsNormalDefault.breath.day.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.day.timeUp =
          this.thrsNormalDefault.breath.day.timeUp;
      }
      if (this.thrsNormal.breath.night.timeLow != null) {
        this.thrsNormalDefaultTime.breath.night.timeLow = this.$moment(
          this.thrsNormal.breath.night.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.night.timeLow =
          this.thrsNormal.breath.night.timeLow;
      } else {
        this.thrsNormalDefaultTime.breath.night.timeLow = this.$moment(
          this.thrsNormalDefault.breath.night.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.night.timeLow =
          this.thrsNormalDefault.breath.night.timeLow;
      }
      if (this.thrsNormal.breath.night.timeUp != null) {
        this.thrsNormalDefaultTime.breath.night.timeUp = this.$moment(
          this.thrsNormal.breath.night.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.night.timeUp =
          this.thrsNormal.breath.night.timeUp;
      } else {
        this.thrsNormalDefaultTime.breath.night.timeUp = this.$moment(
          this.thrsNormalDefault.breath.night.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.breath.night.timeUp =
          this.thrsNormalDefault.breath.night.timeUp;
      }
      if (this.thrsNormal.heart.day.timeLow != null) {
        this.thrsNormalDefaultTime.heart.day.timeLow = this.$moment(
          this.thrsNormal.heart.day.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.day.timeLow =
          this.thrsNormal.heart.day.timeLow;
      } else {
        this.thrsNormalDefaultTime.heart.day.timeLow = this.$moment(
          this.thrsNormalDefault.heart.day.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.day.timeLow =
          this.thrsNormalDefault.heart.day.timeLow;
      }
      if (this.thrsNormal.heart.day.timeUp != null) {
        this.thrsNormalDefaultTime.heart.day.timeUp = this.$moment(
          this.thrsNormal.heart.day.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.day.timeUp = this.thrsNormal.heart.day.timeUp;
      } else {
        this.thrsNormalDefaultTime.heart.day.timeUp = this.$moment(
          this.thrsNormalDefault.heart.day.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.day.timeUp =
          this.thrsNormalDefault.heart.day.timeUp;
      }
      if (this.thrsNormal.heart.night.timeLow != null) {
        this.thrsNormalDefaultTime.heart.night.timeLow = this.$moment(
          this.thrsNormal.heart.night.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.night.timeLow =
          this.thrsNormal.heart.night.timeLow;
      } else {
        this.thrsNormalDefaultTime.heart.night.timeLow = this.$moment(
          this.thrsNormalDefault.heart.night.timeLow,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.night.timeLow =
          this.thrsNormalDefault.heart.night.timeLow;
      }
      if (this.thrsNormal.heart.night.timeUp != null) {
        this.thrsNormalDefaultTime.heart.night.timeUp = this.$moment(
          this.thrsNormal.heart.night.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.night.timeUp =
          this.thrsNormal.heart.night.timeUp;
      } else {
        this.thrsNormalDefaultTime.heart.night.timeUp = this.$moment(
          this.thrsNormalDefault.heart.night.timeUp,
          "hh:mm"
        );
        this.thrsNormalTemp.heart.night.timeUp =
          this.thrsNormalDefault.heart.night.timeUp;
      }
    },
    submitChange() {
      this.activeAlarmData = this.alarmData;
      this.activeAlarmData[0].continued = this.timeToStr(this.thrs.outBed);
      this.switchCheck.outBed ? (this.activeAlarmData[0].enable = 1) : (this.activeAlarmData[0].enable = 0);

      this.activeAlarmData[1].continued = this.timeToStr(this.thrs.fall);
      this.switchCheck.fall
        ? (this.activeAlarmData[1].enable = 1)
        : (this.activeAlarmData[1].enable = 0);
         this.switchCheck.phoneAlarm
        ? (this.activeAlarmData[1].methodsList[0].enable =1)
        : (this.activeAlarmData[1].methodsList[0].enable = 0);
      this.activeAlarmData[2].continued = this.timeToStr(this.thrs.breath);
      this.activeAlarmData[2].bpm = this.thrs.breathBpm.toString();
      this.switchCheck.breath
        ? (this.activeAlarmData[2].enable = 1)
        : (this.activeAlarmData[2].enable = 0);
			this.switchCheck.breathPhoneAlarm
        ? (this.activeAlarmData[2].methodsList[0].enable =1)
        : (this.activeAlarmData[2].methodsList[0].enable = 0);
      this.activeAlarmData[3].continued = this.timeToStr(this.thrs.apnea);
      this.activeAlarmData[3].bpm = this.thrs.apneaMm.toString();
      this.switchCheck.apnea
        ? (this.activeAlarmData[3].enable = 1)
        : (this.activeAlarmData[3].enable = 0);
			this.switchCheck.apneaPhoneAlarm
        ? (this.activeAlarmData[3].methodsList[0].enable =1)
        : (this.activeAlarmData[3].methodsList[0].enable = 0);
      this.activeAlarmData[5].continued = this.timeToStr(this.thrs.heart);
      this.activeAlarmData[5].bpm = this.thrs.heartBpm.toString();
      this.switchCheck.heart
        ? (this.activeAlarmData[5].enable = 1)
        : (this.activeAlarmData[5].enable = 0);
			this.switchCheck.heartPhoneAlarm
        ? (this.activeAlarmData[5].methodsList[0].enable =1)
        : (this.activeAlarmData[5].methodsList[0].enable = 0);
      this.activeAlarmData[4].continued = this.timeToStr(this.thrs.heartBra);
      this.activeAlarmData[4].bpm = this.thrs.heartBraBpm.toString();
      this.switchCheck.heartBra
        ? (this.activeAlarmData[4].enable = 1)
        : (this.activeAlarmData[4].enable = 0);
			this.switchCheck.heartBraPhoneAlarm
        ? (this.activeAlarmData[4].methodsList[0].enable =1)
        : (this.activeAlarmData[4].methodsList[0].enable = 0);

      this.activeAlarmData[6].continued = this.timeToStr(this.thrs.outBed);
         this.switchCheck.toitet
        ? (this.activeAlarmData[6].enable = 1)
        : (this.activeAlarmData[6].enable = 0);
      this.switchCheck.toitetPhoneAlarm
        ? (this.activeAlarmData[6].methodsList[0].enable =1)
        : (this.activeAlarmData[6].methodsList[0].enable = 0);
        


      this.setAlarmData();
      this.activeMonitoringData = this.monitoringData;
      this.activeMonitoringData[0].startBpm =
        this.thrsNormal.breath.day.bpmLow.toString();
      this.activeMonitoringData[0].endBpm =
        this.thrsNormal.breath.day.bpmUp.toString();
      this.activeMonitoringData[0].startTime =
        this.thrsNormal.breath.day.timeLow;
      this.activeMonitoringData[0].endTime = this.thrsNormal.breath.day.timeUp;
      this.activeMonitoringData[1].startBpm =
        this.thrsNormal.breath.night.bpmLow.toString();
      this.activeMonitoringData[1].endBpm =
        this.thrsNormal.breath.night.bpmUp.toString();
      this.activeMonitoringData[1].startTime =
        this.thrsNormal.breath.night.timeLow;
      this.activeMonitoringData[1].endTime =
        this.thrsNormal.breath.night.timeUp;
      this.activeMonitoringData[2].startBpm =
        this.thrsNormal.heart.day.bpmLow.toString();
      this.activeMonitoringData[2].endBpm =
        this.thrsNormal.heart.day.bpmUp.toString();
      this.activeMonitoringData[2].startTime =
        this.thrsNormal.heart.day.timeLow;
      this.activeMonitoringData[2].endTime = this.thrsNormal.heart.day.timeUp;
      this.activeMonitoringData[3].startBpm =
        this.thrsNormal.heart.night.bpmLow.toString();
      this.activeMonitoringData[3].endBpm =
        this.thrsNormal.heart.night.bpmUp.toString();
      this.activeMonitoringData[3].startTime =
        this.thrsNormal.heart.night.timeLow;
      this.activeMonitoringData[3].endTime = this.thrsNormal.heart.night.timeUp;
      if (this.switchCheck.realTimeMon) {
        this.activeMonitoringData[0].enable = 1;
        this.activeMonitoringData[1].enable = 1;
        this.activeMonitoringData[2].enable = 1;
        this.activeMonitoringData[3].enable = 1;
      } else {
        this.activeMonitoringData[0].enable = 0;
        this.activeMonitoringData[1].enable = 0;
        this.activeMonitoringData[2].enable = 0;
        this.activeMonitoringData[3].enable = 0;
      }
      this.setMonitoringData();
      this.activeHealthBigData = this.healthBigData;
      this.activeHealthBigData[0].enable = this.switchCheck.healthReport
        ? 1
        : 0;
      this.activeHealthBigData[1].enable = this.switchCheck.healthReportCheck
        ? 1
        : 0;
      this.activeHealthBigData[2].enable = this.switchCheck.checkInfo ? 1 : 0;
      this.activeHealthBigData[3].enable = this.switchCheck.healthInfo ? 1 : 0;
      this.activeHealthBigData[4].enable = this.switchCheck.workEffi ? 1 : 0;
      this.activeHealthBigData[5].enable = this.switchCheck.opeData ? 1 : 0;
      this.activeHealthBigData[6].enable = this.switchCheck.realTimeOpe ? 1 : 0;
      this.activeHealthBigData[7].enable = this.switchCheck.fourG_check ? 1 : 0;
      this.setHealthBigData();
      this.functionVisible = false;
    },
    colorBtn() {
      this.colorHide = this.colorHide ? false : true;
    },
    // 颜色选择
    colorItemBtn(item) {
      this.backGroundColor = item;
      this.colorHide = false;
    },
    functionClick(scope) {
		this.switchCheck = {
        toitet:true,
        toitetPhoneAlarm:true,
        phoneAlarm:true,
        outBed: true,
        fall: true,
        breath: true,
				breathPhoneAlarm: true,
        apnea: true,
				apneaPhoneAlarm: true,
        heart: false,
				heartPhoneAlarm: true,
        heartBra: true,
				heartBraPhoneAlarm: true,
        realTimeMon: true,
        healthReport: true,
        healthReportCheck: true,
        checkInfo: true,
        healthInfo: true,
        workEffi: true,
        opeData: true,
        realTimeOpe: true,
      }
	  this.outBedThrsShow = false;
	  this.fallThrsShow = false;
	  this.breathThrsShow = false;
	  this.apneaThrsShow = false;
	  this.heartThrsShow = false;
	  this.heartBraThrsShow = false;
	  this.norShowChange =  {
        breath: {
          dayBpm: false,
          dayTime: false,
          nightBpm: false,
          nightTime: false,
        },
        heart: {
          dayBpm: false,
          dayTime: false,
          nightBpm: false,
          nightTime: false,
        },
      },


      this.activeTenantId = scope.id;
      this.getAlarmData();
      this.getMonitoringData();
      this.getHealthBigData();
      // this.setDefaultThrs();
      this.setDefaultThrsTime();
      this.activeTitle = scope.name + "功能设置";
      // console.log(this.switchCheck);
      this.functionVisible = true;
      // this.setAlarmData();
      // this.setMonitoringData();
      // this.setHealthBigData();
    },
    outBedSwitch(checked) {
      this.switchCheck.outBed = checked;
    },
    fallSwitch(checked) {
      if(checked) {
        this.switchCheck.fall = checked;
      } else {
        this.switchCheck.fall = checked;
        this.switchCheck.phoneAlarm = checked;
      }
      
    },
    
    phoneAlarmSwitch(checked) {
      this.switchCheck.phoneAlarm = checked;
    },
    toitetFallSwitch(checked) {
      if(checked) {
        this.switchCheck.toitet = checked;
      } else {
        this.switchCheck.toitet = checked;
        this.switchCheck.toitetPhoneAlarm = checked;
      }
      
    },
    
    toitetPhoneAlarmSwitch(checked) {
      this.switchCheck.toitetPhoneAlarm = checked;
    },
    breathSwitch(checked) {
      this.switchCheck.breath = checked;
			if (!checked) {
				this.switchCheck.breathPhoneAlarm = checked;
				this.breathThrsShow = false;
			}
    },
		breathPhoneAlarmSwitch(checked) {
			this.switchCheck.breathPhoneAlarm = checked;
		},
    apneaSwitch(checked) {
      this.switchCheck.apnea = checked;
			if (!checked) {
				this.switchCheck.apneaPhoneAlarm = checked;
			}
    },
		apneaPhoneAlarmSwitch(checked) {
			this.switchCheck.apneaPhoneAlarm = checked;
		},
    heartSwitch(checked) {
      this.switchCheck.heart = checked;
			if (!checked) {
				this.switchCheck.heartPhoneAlarm = checked;
			}
    },
		heartPhoneAlarmSwitch(checked) {
			this.switchCheck.heartPhoneAlarm = checked;
		},
    heartBraSwitch(checked) {
      this.switchCheck.heartBra = checked;
			if (!checked) {
				this.switchCheck.heartBraPhoneAlarm = checked;
			}
    },
		heartBraPhoneAlarmSwitch(checked) {
			this.switchCheck.heartBraPhoneAlarm = checked;
		},
    realTimeSwitch(checked) {
      this.switchCheck.realTimeMon = checked;
    },
    healthReportSwitch(checked) {
      this.switchCheck.healthReport = checked;
    },
    fourG_checkSwitch(checked) {
      this.switchCheck.fourG_check = checked;
      this.$forceUpdate()
    },
    healthReportCheckSwitch(checked) {
      this.switchCheck.healthReportCheck = checked;
    },
    checkInfoSwitch(checked) {
      this.switchCheck.checkInfo = checked;
    },
    healthInfoSwitch(checked) {
      this.switchCheck.healthInfo = checked;
    },
    workEffiSwitch(checked) {
      this.switchCheck.workEffi = checked;
    },
    opeDataSwitch(checked) {
      this.switchCheck.opeData = checked;
    },
    realTimeOpeSwitch(checked) {
      this.switchCheck.realTimeOpe = checked;
    },
    outBedThrsChange(time, ts) {
      if (ts != "") this.thrsTemp.outBed = ts;
      else this.thrsTemp.outBed = this.thrsDefault.outBed;
    },
    outBedThrsConfirm() {
      if (this.thrsTemp.outBed != null) this.thrs.outBed = this.thrsTemp.outBed;
      else this.thrs.outBed = this.thrsDefault.outBed;
      this.outBedThrsShow = false;
    },
    outBedReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrs.outBed = that.thrsDefault.outBed;
          that.thrsTemp.outBed = null;
          that.outBedThrsShow = false;
          that.setDefaultThrsTime();
        },
      });
    },
    fallThrsChange(time, ts) {
      if (ts != "") this.thrsTemp.fall = ts;
      else this.thrsTemp.fall = this.thrsDefault.fall;
    },
    fallThrsConfirm() {
      if (this.thrsTemp.fall != null) this.thrs.fall = this.thrsTemp.fall;
      else this.thrs.fall = this.thrsDefault.fall;
      this.fallThrsShow = false;
    },
    fallReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrs.fall = that.thrsDefault.fall;
          that.thrsTemp.fall = null;
          that.fallThrsShow = false;
          that.setDefaultThrsTime();
        },
      });
    },
    breathThrsChange(time, ts) {
      if (ts != "") this.thrsTemp.breath = ts;
      else this.thrsTemp.breath = this.thrsDefault.breath;
    },
    breathBpmChange(value) {
      if (value) this.thrsTemp.breathBpm = value;
      else this.thrsTemp.breathBpm = this.thrsDefault.breathBpm;
    },
    breathThrsConfirm() {
      var that = this;
      if (
        (that.thrsTemp.breathBpm >= that.thrsNormal.breath.day.bpmLow &&
          that.thrsTemp.breathBpm <= that.thrsNormal.breath.day.bpmUp) ||
        (that.thrsTemp.breathBpm >= that.thrsNormal.breath.night.bpmLow &&
          that.thrsTemp.breathBpm <= that.thrsNormal.breath.night.bpmUp)
      ) {
        that.conflictValues.breath = true;
        that.$confirm({
          title: "呼吸过速的报警阈值和呼吸正常阈值有矛盾，需要修改吗？",
          okText: "继续",
          cancelText: "返回修改",
          onOk() {
            that.breathThrsConfirmExe();
          },
        });
      } else {
        that.conflictValues.breath = false;
        that.breathThrsConfirmExe();
      }
    },
    breathThrsConfirmExe() {
      if (this.thrsTemp.breath != null) {
		this.thrs.breath = this.thrsTemp.breath;
	  } else {
		this.thrs.breath = this.thrsDefault.breath;
	  }
	  // 旧代码
      //   if (this.thrsTemp.breathBpm != null) {
	  // 	this.thrs.breathBpm = this.thrsTemp.breathBpm;
	  //   } else {
	  // 	this.thrs.breathBpm = this.thrsDefault.breathBpm;
	  //   }
	  // 新代码
	  if (this.thrsTemp.breathBpm != null) {
		this.thrs.breathBpm = this.thrsTemp.breathBpm;
	  } else {
		if (this.thrs.breathBpm == null) {
			this.thrs.breathBpm = this.thrsDefault.breathBpm;
		}
	  }
      this.breathThrsShow = false;
    },
    breathReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrs.breath = that.thrsDefault.breath;
          that.thrs.breathBpm = that.thrsDefault.breathBpm;
          that.thrsTemp.breath = null;
          that.thrsTemp.breathBpm = null;
          that.breathThrsShow = false;
					that.switchCheck.breath = true;
					that.switchCheck.breathPhoneAlarm = false;
          that.checkConflict();
          that.setDefaultThrsTime();
        },
      });
    },
    alarmFallReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
        that.switchCheck.phoneAlarm = false
        that.switchCheck.fall = true
        },
      });
    },
    toitetAlarmFallReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
        that.switchCheck.toitetPhoneAlarm = false
        that.switchCheck.toitet = true
        },
      });
    },
    apneaThrsChange(time, ts) {
      if (ts != "") this.thrsTemp.apnea = ts;
      else this.thrsTemp.apnea = this.thrsDefault.apnea;
    },
    apneaMmChange(value) {
      if (value) this.thrsTemp.apneaMm = value;
      else this.thrsTemp.apneaMm = this.thrsDefault.apneaMm;
    },
    apneaThrsConfirm() {
      console.log(this.thrs.apneaMm)
      if (this.thrsTemp.apnea != null) this.thrs.apnea = this.thrsTemp.apnea;
      else this.thrs.apnea = this.thrsDefault.apnea;
      if (this.thrsTemp.apneaMm != null)
        this.thrs.apneaMm = this.thrsTemp.apneaMm;
      else this.thrs.apneaMm = this.thrsDefault.apneaMm;
      this.apneaThrsShow = false;
      console.log(this.thrs.apneaMm)
    },
    apneaReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrs.apnea = that.thrsDefault.apnea;
          that.thrs.apneaMm = that.thrsDefault.apneaMm;
          that.thrsTemp.apnea = null;
          that.thrsTemp.apneaMm = null;
          that.apneaThrsShow = false;
					that.switchCheck.apnea = true;
					that.switchCheck.apneaPhoneAlarm = false;
          that.setDefaultThrsTime();
        },
      });
    },
    heartThrsChange(time, ts) {
      if (ts != "") this.thrsTemp.heart = ts;
      else this.thrsTemp.heart = this.thrsDefault.heart;
    },
    heartBpmChange(value) {
      if (value) this.thrsTemp.heartBpm = value;
      else this.thrsTemp.heartBpm = this.thrsDefault.heartBpm;
    },
    heartThrsConfirm() {
      var that = this;
      if (
        (that.thrsTemp.heartBpm >= that.thrsNormal.heart.day.bpmLow &&
          that.thrsTemp.heartBpm <= that.thrsNormal.heart.day.bpmUp) ||
        (that.thrsTemp.heartBpm >= that.thrsNormal.heart.night.bpmLow &&
          that.thrsTemp.heartBpm <= that.thrsNormal.heart.night.bpmUp)
      ) {
        that.conflictValues.heart = true;
        that.$confirm({
          title: "心跳过速的报警阈值和心跳正常阈值有矛盾，需要修改吗？",
          okText: "继续",
          cancelText: "返回修改",
          onOk() {
            that.heartThrsConfirmExe();
          },
        });
      } else {
        that.conflictValues.heart = false;
        that.heartThrsConfirmExe();
      }
    },
    heartThrsConfirmExe() {
      if (this.thrsTemp.heart != null) {
		this.thrs.heart = this.thrsTemp.heart;
	  } else {
		this.thrs.heart = this.thrsDefault.heart;
	  }
	  // 旧代码
    //   if (this.thrsTemp.heartBpm != null) {
	// 	this.thrs.heartBpm = this.thrsTemp.heartBpm;
	//   } else {
	// 	this.thrs.heartBpm = this.thrsDefault.heartBpm;
	//   }
	  // 新代码
      if (this.thrsTemp.heartBpm != null) {
		this.thrs.heartBpm = this.thrsTemp.heartBpm;
	  } else {
		if (this.thrs.heartBpm == null) {
			this.thrs.heartBpm = this.thrsDefault.heartBpm;
		}
	  }
      this.heartThrsShow = false;
    },
    heartReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrs.heart = that.thrsDefault.heart;
          that.thrs.heartBpm = that.thrsDefault.heartBpm;
          that.thrsTemp.heart = null;
          that.thrsTemp.heartBpm = null;
          that.heartThrsShow = false;
          that.checkConflict();
          that.setDefaultThrsTime();
        },
      });
    },
    heartBraThrsChange(time, ts) {
      if (ts != "") this.thrsTemp.heartBra = ts;
      else this.thrsTemp.heartBra = this.thrsDefault.heartBra;
    },
    heartBraBpmChange(value) {
      if (value) this.thrsTemp.heartBraBpm = value;
      else this.thrsTemp.heartBraBpm = this.thrsDefault.heartBraBpm;
    },
    heartBraThrsConfirm() {
      var that = this;
      if (
        (that.thrsTemp.heartBraBpm >= that.thrsNormal.heart.day.bpmLow &&
          that.thrsTemp.heartBraBpm <= that.thrsNormal.heart.day.bpmUp) ||
        (that.thrsTemp.heartBraBpm >= that.thrsNormal.heart.night.bpmLow &&
          that.thrsTemp.heartBraBpm <= that.thrsNormal.heart.night.bpmUp)
      ) {
        that.conflictValues.heartBra = true;
        that.$confirm({
          title: "心跳过缓的报警阈值和心跳正常阈值有矛盾，需要修改吗？",
          okText: "继续",
          cancelText: "返回修改",
          onOk() {
            that.heartBraThrsConfirmExe();
          },
        });
      } else {
        that.conflictValues.heartBra = false;
        that.heartBraThrsConfirmExe();
      }
    },
    heartBraThrsConfirmExe() {
      if (this.thrsTemp.heartBra != null) {
		this.thrs.heartBra = this.thrsTemp.heartBra;
	  } else {
		this.thrs.heartBra = this.thrsDefault.heartBra;
	  }
	  // 旧代码
    //   if (this.thrsTemp.heartBraBpm != null) {
	// 	this.thrs.heartBraBpm = this.thrsTemp.heartBraBpm;
	//   } else {
	// 	this.thrs.heartBraBpm = this.thrsDefault.heartBraBpm;
	//   }
	  // 新代码
      if (this.thrsTemp.heartBraBpm != null) {
		this.thrs.heartBraBpm = this.thrsTemp.heartBraBpm;
	  } else {
		if (this.thrs.heartBraBpm == null) {
			this.thrs.heartBraBpm = this.thrsDefault.heartBraBpm;
		}
	  }
      this.heartBraThrsShow = false;
    },
    heartBraReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrs.heartBra = that.thrsDefault.heartBra;
          that.thrs.heartBraBpm = that.thrsDefault.heartBraBpm;
          that.thrsTemp.heartBra = null;
          that.thrsTemp.heartBraBpm = null;
          that.heartBraThrsShow = false;
          that.checkConflict();
          that.setDefaultThrsTime();
        },
      });
    },
    breathDayBpmLowChange(value) {
      if (value) this.thrsNormalTemp.breath.day.bpmLow = value;
      else
        this.thrsNormalTemp.breath.day.bpmLow =
          this.thrsNormalDefault.breath.day.bpmLow;
    },
    breathDayBpmUpChange(value) {
      if (value) this.thrsNormalTemp.breath.day.bpmUp = value;
      else
        this.thrsNormalTemp.breath.day.bpmUp =
          this.thrsNormalDefault.breath.day.bpmUp;
    },
    breathDayTimeLowChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.breath.day.timeLow = ts;
      else
        this.thrsNormalTemp.breath.day.timeLow =
          this.thrsNormalDefault.breath.day.timeLow;
    },
    breathDayTimeUpChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.breath.day.timeUp = ts;
      else
        this.thrsNormalTemp.breath.day.timeUp =
          this.thrsNormalDefault.breath.day.timeUp;
    },
    breathDayBpmConfirm() {
      var that = this;
      var b1 =
        this.thrsNormalTemp.breath.day.bpmLow != null
          ? this.thrsNormalTemp.breath.day.bpmLow
          : this.thrsNormalDefault.breath.day.bpmLow;
      var b2 =
        this.thrsNormalTemp.breath.day.bpmUp != null
          ? this.thrsNormalTemp.breath.day.bpmUp
          : this.thrsNormalDefault.breath.day.bpmUp;
      if (b1 >= b2) {
        that.conflictValues.breathThrs = true;
        that.$warning({
          title: "呼吸正常阈值有矛盾，需要修改",
          okText: "返回修改",
        });
      } else {
        if (this.thrsNormalTemp.breath.day.bpmLow != null)
          this.thrsNormal.breath.day.bpmLow =
            this.thrsNormalTemp.breath.day.bpmLow;
        else
          this.thrsNormal.breath.day.bpmLow =
            this.thrsNormalDefault.breath.day.bpmLow;
        if (this.thrsNormalTemp.breath.day.bpmUp != null)
          this.thrsNormal.breath.day.bpmUp =
            this.thrsNormalTemp.breath.day.bpmUp;
        else
          this.thrsNormal.breath.day.bpmUp =
            this.thrsNormalDefault.breath.day.bpmUp;
        this.norShowChange.breath.dayBpm = false;
        this.checkConflict();
      }
    },
    breathDayTimeConfirm() {
      var that = this;
      var t1 = that.$moment(that.thrsNormalTemp.breath.day.timeLow, "hh:mm");
      var t2 = that.$moment(that.thrsNormalTemp.breath.day.timeUp, "hh:mm");
      var t3 = that.$moment(that.thrsNormal.breath.night.timeLow, "hh:mm");
      var t4 = that.$moment(that.thrsNormal.breath.night.timeUp, "hh:mm");
      var warn1 = false;
      var warn2 = false;
      if (t1.diff(t4, "minutes") != 1 || t3.diff(t2, "minutes") != 1)
        warn1 = true;

      if (t2.diff(t1, "minutes") > 0) {
        if (
          (t3.diff(t1, "minutes") > 0 && t2.diff(t3, "minutes") > 0) ||
          (t4.diff(t1, "minutes") > 0 && t2.diff(t4, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t3.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t4, "minutes") > 0
        )
          warn2 = true;
      }
      if (t4.diff(t3, "minutes") > 0) {
        if (
          (t1.diff(t3, "minutes") > 0 && t4.diff(t1, "minutes") > 0) ||
          (t2.diff(t3, "minutes") > 0 && t4.diff(t2, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t1.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t2, "minutes") > 0
        )
          warn2 = true;
      }
      if (warn2) {
        that.conflictValues.breathThrs = true;
        that.$warning({
          title: "呼吸正常阈值时间段有重叠，需要修改",
          okText: "返回修改",
        });
      } else if (warn1) {
        that.conflictValues.breathThrs = true;
        that.$confirm({
          title: "呼吸正常阈值时间段没有覆盖全天，需要修改吗？",
          okText: "继续",
          cancelText: "返回修改",
          onOk() {
            that.breathDayTimeConfirmExe();
          },
        });
      } else {
        that.conflictValues.breathThrs = false;
        that.breathDayTimeConfirmExe();
      }
    },
    breathDayTimeConfirmExe() {
      if (this.thrsNormalTemp.breath.day.timeLow != null)
        this.thrsNormal.breath.day.timeLow =
          this.thrsNormalTemp.breath.day.timeLow;
      else
        this.thrsNormal.breath.day.timeLow =
          this.thrsNormalDefault.breath.day.timeLow;
      if (this.thrsNormalTemp.breath.day.timeUp != null)
        this.thrsNormal.breath.day.timeUp =
          this.thrsNormalTemp.breath.day.timeUp;
      else
        this.thrsNormal.breath.day.timeUp =
          this.thrsNormalDefault.breath.day.timeUp;
      this.norShowChange.breath.dayTime = false;
      this.setDefaultThrsTime();
    },
    breathDayReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrsNormal.breath.day.bpmLow =
            that.thrsNormalDefault.breath.day.bpmLow;
          that.thrsNormal.breath.day.bpmUp =
            that.thrsNormalDefault.breath.day.bpmUp;
          that.thrsNormal.breath.day.timeLow =
            that.thrsNormalDefault.breath.day.timeLow;
          that.thrsNormal.breath.day.timeUp =
            that.thrsNormalDefault.breath.day.timeUp;
          that.thrsNormalTemp.breath.day.bpmLow = null;
          that.thrsNormalTemp.breath.day.bpmUp = null;
          that.thrsNormalTemp.breath.day.timeLow = null;
          that.thrsNormalTemp.breath.day.timeUp = null;
          that.checkConflict();
          that.setDefaultThrsTime();
        },
      });
    },
    breathNightBpmLowChange(value) {
      if (value) this.thrsNormalTemp.breath.night.bpmLow = value;
      else
        this.thrsNormalTemp.breath.night.bpmLow =
          this.thrsNormalDefault.breath.night.bpmLow;
    },
    breathNightBpmUpChange(value) {
      if (value) this.thrsNormalTemp.breath.night.bpmUp = value;
      else
        this.thrsNormalTemp.breath.night.bpmUp =
          this.thrsNormalDefault.breath.night.bpmUp;
    },
    breathNightTimeLowChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.breath.night.timeLow = ts;
      else
        this.thrsNormalTemp.breath.night.timeLow =
          this.thrsNormalDefault.breath.night.timeLow;
    },
    breathNightTimeUpChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.breath.night.timeUp = ts;
      else
        this.thrsNormalTemp.breath.night.timeUp =
          this.thrsNormalDefault.breath.night.timeUp;
    },
    breathNightBpmConfirm() {
      var that = this;
      var b1 =
        this.thrsNormalTemp.breath.night.bpmLow != null
          ? this.thrsNormalTemp.breath.night.bpmLow
          : this.thrsNormalDefault.breath.night.bpmLow;
      var b2 =
        this.thrsNormalTemp.breath.night.bpmUp != null
          ? this.thrsNormalTemp.breath.night.bpmUp
          : this.thrsNormalDefault.breath.night.bpmUp;
      if (b1 >= b2) {
        that.conflictValues.breathThrs = true;
        that.$warning({
          title: "呼吸正常阈值有矛盾，需要修改",
          okText: "返回修改",
        });
      } else {
        if (this.thrsNormalTemp.breath.night.bpmLow != null)
          this.thrsNormal.breath.night.bpmLow =
            this.thrsNormalTemp.breath.night.bpmLow;
        else
          this.thrsNormal.breath.night.bpmLow =
            this.thrsNormalDefault.breath.night.bpmLow;
        if (this.thrsNormalTemp.breath.night.bpmUp != null)
          this.thrsNormal.breath.night.bpmUp =
            this.thrsNormalTemp.breath.night.bpmUp;
        else
          this.thrsNormal.breath.night.bpmUp =
            this.thrsNormalDefault.breath.night.bpmUp;
        this.norShowChange.breath.nightBpm = false;
        this.checkConflict();
      }
    },
    breathNightTimeConfirm() {
      var that = this;
      var t1 = that.$moment(that.thrsNormal.breath.day.timeLow, "hh:mm");
      var t2 = that.$moment(that.thrsNormal.breath.day.timeUp, "hh:mm");
      var t3 = that.$moment(that.thrsNormalTemp.breath.night.timeLow, "hh:mm");
      var t4 = that.$moment(that.thrsNormalTemp.breath.night.timeUp, "hh:mm");
      var warn1 = false;
      var warn2 = false;
      if (t1.diff(t4, "minutes") != 1 || t3.diff(t2, "minutes") != 1)
        warn1 = true;
      if (t2.diff(t1, "minutes") > 0) {
        if (
          (t3.diff(t1, "minutes") > 0 && t2.diff(t3, "minutes") > 0) ||
          (t4.diff(t1, "minutes") > 0 && t2.diff(t4, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t3.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t4, "minutes") > 0
        )
          warn2 = true;
      }
      if (t4.diff(t3, "minutes") > 0) {
        if (
          (t1.diff(t3, "minutes") > 0 && t4.diff(t1, "minutes") > 0) ||
          (t2.diff(t3, "minutes") > 0 && t4.diff(t2, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t1.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t2, "minutes") > 0
        )
          warn2 = true;
      }
      if (warn2) {
        that.conflictValues.breathThrs = true;
        that.$warning({
          title: "呼吸正常阈值时间段有重叠，需要修改",
          okText: "返回修改",
        });
      } else if (warn1) {
        that.conflictValues.breathThrs = true;
        that.$confirm({
          title: "呼吸正常阈值时间段没有覆盖全天，需要修改吗？",
          okText: "继续",
          cancelText: "返回修改",
          onOk() {
            that.breathNightTimeConfirmExe();
          },
        });
      } else {
        that.conflictValues.breathThrs = false;
        that.breathNightTimeConfirmExe();
      }
    },
    breathNightTimeConfirmExe() {
      if (this.thrsNormalTemp.breath.night.timeLow != null)
        this.thrsNormal.breath.night.timeLow =
          this.thrsNormalTemp.breath.night.timeLow;
      else
        this.thrsNormal.breath.night.timeLow =
          this.thrsNormalDefault.breath.night.timeLow;
      if (this.thrsNormalTemp.breath.night.timeUp != null)
        this.thrsNormal.breath.night.timeUp =
          this.thrsNormalTemp.breath.night.timeUp;
      else
        this.thrsNormal.breath.night.timeUp =
          this.thrsNormalDefault.breath.night.timeUp;
      this.norShowChange.breath.nightTime = false;
      this.setDefaultThrsTime();
    },
    breathNightReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrsNormal.breath.night.bpmLow =
            that.thrsNormalDefault.breath.night.bpmLow;
          that.thrsNormal.breath.night.bpmUp =
            that.thrsNormalDefault.breath.night.bpmUp;
          that.thrsNormal.breath.night.timeLow =
            that.thrsNormalDefault.breath.night.timeLow;
          that.thrsNormal.breath.night.timeUp =
            that.thrsNormalDefault.breath.night.timeUp;
          that.thrsNormalTemp.breath.night.bpmLow = null;
          that.thrsNormalTemp.breath.night.bpmUp = null;
          that.thrsNormalTemp.breath.night.timeLow = null;
          that.thrsNormalTemp.breath.night.timeUp = null;
          that.checkConflict();
          that.setDefaultThrsTime();
        },
      });
    },
    heartDayBpmLowChange(value) {
      if (value) this.thrsNormalTemp.heart.day.bpmLow = value;
      else
        this.thrsNormalTemp.heart.day.bpmLow =
          this.thrsNormalDefault.heart.day.bpmLow;
    },
    heartDayBpmUpChange(value) {
      if (value) this.thrsNormalTemp.heart.day.bpmUp = value;
      else
        this.thrsNormalTemp.heart.day.bpmUp =
          this.thrsNormalDefault.heart.day.bpmUp;
    },
    heartDayTimeLowChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.heart.day.timeLow = ts;
      else
        this.thrsNormalTemp.heart.day.timeLow =
          this.thrsNormalDefault.heart.day.timeLow;
    },
    heartDayTimeUpChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.heart.day.timeUp = ts;
      else
        this.thrsNormalTemp.heart.day.timeUp =
          this.thrsNormalDefault.heart.day.timeUp;
    },
    heartDayBpmConfirm() {
      var that = this;
      var b1 =
        this.thrsNormalTemp.heart.day.bpmLow != null
          ? this.thrsNormalTemp.heart.day.bpmLow
          : this.thrsNormalDefault.heart.day.bpmLow;
      var b2 =
        this.thrsNormalTemp.heart.day.bpmUp != null
          ? this.thrsNormalTemp.heart.day.bpmUp
          : this.thrsNormalDefault.heart.day.bpmUp;
      if (b1 >= b2) {
        that.conflictValues.heartThrs = true;
        that.$warning({
          title: "心跳正常阈值有矛盾，需要修改",
          okText: "返回修改",
        });
      } else {
        if (this.thrsNormalTemp.heart.day.bpmLow != null)
          this.thrsNormal.heart.day.bpmLow =
            this.thrsNormalTemp.heart.day.bpmLow;
        else
          this.thrsNormal.heart.day.bpmLow =
            this.thrsNormalDefault.heart.day.bpmLow;
        if (this.thrsNormalTemp.heart.day.bpmUp != null)
          this.thrsNormal.heart.day.bpmUp = this.thrsNormalTemp.heart.day.bpmUp;
        else
          this.thrsNormal.heart.day.bpmUp =
            this.thrsNormalDefault.heart.day.bpmUp;
        this.norShowChange.heart.dayBpm = false;
        this.checkConflict();
      }
    },
    heartDayTimeConfirm() {
      var that = this;
      var t1 = that.$moment(that.thrsNormalTemp.heart.day.timeLow, "hh:mm");
      var t2 = that.$moment(that.thrsNormalTemp.heart.day.timeUp, "hh:mm");
      var t3 = that.$moment(that.thrsNormal.heart.night.timeLow, "hh:mm");
      var t4 = that.$moment(that.thrsNormal.heart.night.timeUp, "hh:mm");
      var warn1 = false;
      var warn2 = false;
      if (t1.diff(t4, "minutes") != 1 || t3.diff(t2, "minutes") != 1)
        warn1 = true;
      if (t2.diff(t1, "minutes") > 0) {
        if (
          (t3.diff(t1, "minutes") > 0 && t2.diff(t3, "minutes") > 0) ||
          (t4.diff(t1, "minutes") > 0 && t2.diff(t4, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t3.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t4, "minutes") > 0
        )
          warn2 = true;
      }
      if (t4.diff(t3, "minutes") > 0) {
        if (
          (t1.diff(t3, "minutes") > 0 && t4.diff(t1, "minutes") > 0) ||
          (t2.diff(t3, "minutes") > 0 && t4.diff(t2, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t1.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t2, "minutes") > 0
        )
          warn2 = true;
      }
      if (warn2) {
        that.conflictValues.heartThrs = true;
        that.$warning({
          title: "心跳正常阈值时间段有重叠，需要修改",
          okText: "返回修改",
        });
      } else if (warn1) {
        that.conflictValues.heartThrs = true;
        that.$confirm({
          title: "心跳正常阈值时间段没有覆盖全天，需要修改吗？",
          okText: "继续",
          cancelText: "返回修改",
          onOk() {
            that.heartDayTimeConfirmExe();
          },
        });
      } else {
        that.conflictValues.heartThrs = false;
        that.heartDayTimeConfirmExe();
      }
    },
    heartDayTimeConfirmExe() {
      if (this.thrsNormalTemp.heart.day.timeLow != null)
        this.thrsNormal.heart.day.timeLow =
          this.thrsNormalTemp.heart.day.timeLow;
      else
        this.thrsNormal.heart.day.timeLow =
          this.thrsNormalDefault.heart.day.timeLow;
      if (this.thrsNormalTemp.heart.day.timeUp != null)
        this.thrsNormal.heart.day.timeUp = this.thrsNormalTemp.heart.day.timeUp;
      else
        this.thrsNormal.heart.day.timeUp =
          this.thrsNormalDefault.heart.day.timeUp;
      this.norShowChange.heart.dayTime = false;
      this.setDefaultThrsTime();
    },
    heartDayReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrsNormal.heart.day.bpmLow =
            that.thrsNormalDefault.heart.day.bpmLow;
          that.thrsNormal.heart.day.bpmUp =
            that.thrsNormalDefault.heart.day.bpmUp;
          that.thrsNormal.heart.day.timeLow =
            that.thrsNormalDefault.heart.day.timeLow;
          that.thrsNormal.heart.day.timeUp =
            that.thrsNormalDefault.heart.day.timeUp;
          that.thrsNormalTemp.heart.day.bpmLow = null;
          that.thrsNormalTemp.heart.day.bpmUp = null;
          that.thrsNormalTemp.heart.day.timeLow = null;
          that.thrsNormalTemp.heart.day.timeUp = null;
          that.checkConflict();
          that.setDefaultThrsTime();
        },
      });
    },
    heartNightBpmLowChange(value) {
      if (value) this.thrsNormalTemp.heart.night.bpmLow = value;
      else
        this.thrsNormalTemp.heart.night.bpmLow =
          this.thrsNormalDefault.heart.night.bpmLow;
    },
    heartNightBpmUpChange(value) {
      if (value) this.thrsNormalTemp.heart.night.bpmUp = value;
      else
        this.thrsNormalTemp.heart.night.bpmUp =
          this.thrsNormalDefault.heart.night.bpmUp;
    },
    heartNightTimeLowChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.heart.night.timeLow = ts;
      else
        this.thrsNormalTemp.heart.night.timeLow =
          this.thrsNormalDefault.heart.night.timeLow;
    },
    heartNightTimeUpChange(time, ts) {
      if (ts != "") this.thrsNormalTemp.heart.night.timeUp = ts;
      else
        this.thrsNormalTemp.heart.night.timeUp =
          this.thrsNormalDefault.heart.night.timeUp;
    },
    heartNightBpmConfirm() {
      var that = this;
      var b1 =
        this.thrsNormalTemp.heart.night.bpmLow != null
          ? this.thrsNormalTemp.heart.night.bpmLow
          : this.thrsNormalDefault.heart.night.bpmLow;
      var b2 =
        this.thrsNormalTemp.heart.night.bpmUp != null
          ? this.thrsNormalTemp.heart.night.bpmUp
          : this.thrsNormalDefault.heart.night.bpmUp;
      if (b1 >= b2) {
        that.conflictValues.heartThrs = true;
        that.$warning({
          title: "心跳正常阈值有矛盾，需要修改",
          okText: "返回修改",
        });
      } else {
        if (this.thrsNormalTemp.heart.night.bpmLow != null)
          this.thrsNormal.heart.night.bpmLow =
            this.thrsNormalTemp.heart.night.bpmLow;
        else
          this.thrsNormal.heart.night.bpmLow =
            this.thrsNormalDefault.heart.night.bpmLow;
        if (this.thrsNormalTemp.heart.night.bpmUp != null)
          this.thrsNormal.heart.night.bpmUp =
            this.thrsNormalTemp.heart.night.bpmUp;
        else
          this.thrsNormal.heart.night.bpmUp =
            this.thrsNormalDefault.heart.night.bpmUp;
        this.norShowChange.heart.nightBpm = false;
        this.checkConflict();
      }
    },
    heartNightTimeConfirm() {
      var that = this;
      var t1 = that.$moment(that.thrsNormal.heart.day.timeLow, "hh:mm");
      var t2 = that.$moment(that.thrsNormal.heart.day.timeUp, "hh:mm");
      var t3 = that.$moment(that.thrsNormalTemp.heart.night.timeLow, "hh:mm");
      var t4 = that.$moment(that.thrsNormalTemp.heart.night.timeUp, "hh:mm");
      var warn1 = false;
      var warn2 = false;
      if (t1.diff(t4, "minutes") != 1 || t3.diff(t2, "minutes") != 1)
        warn1 = true;
      if (t2.diff(t1, "minutes") > 0) {
        if (
          (t3.diff(t1, "minutes") > 0 && t2.diff(t3, "minutes") > 0) ||
          (t4.diff(t1, "minutes") > 0 && t2.diff(t4, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t3.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t4, "minutes") > 0
        )
          warn2 = true;
      }
      if (t4.diff(t3, "minutes") > 0) {
        if (
          (t1.diff(t3, "minutes") > 0 && t4.diff(t1, "minutes") > 0) ||
          (t2.diff(t3, "minutes") > 0 && t4.diff(t2, "minutes") > 0)
        )
          warn2 = true;
      } else {
        if (
          t1.diff(t3, "minutes") > 0 ||
          t4.diff(t1, "minutes") > 0 ||
          t2.diff(t3, "minutes") > 0 ||
          t4.diff(t2, "minutes") > 0
        )
          warn2 = true;
      }
      if (warn2) {
        that.conflictValues.heartThrs = true;
        that.$warning({
          title: "心跳正常阈值时间段有重叠，需要修改",
          okText: "返回修改",
        });
      } else if (warn1) {
        that.conflictValues.heartThrs = true;
        that.$confirm({
          title: "心跳正常阈值时间段没有覆盖全天，需要修改吗？",
          okText: "继续",
          cancelText: "返回修改",
          onOk() {
            that.heartNightTimeConfirmExe();
          },
        });
      } else {
        that.conflictValues.heartThrs = false;
        that.heartNightTimeConfirmExe();
      }
    },
    heartNightTimeConfirmExe() {
      if (this.thrsNormalTemp.heart.night.timeLow != null)
        this.thrsNormal.heart.night.timeLow =
          this.thrsNormalTemp.heart.night.timeLow;
      else
        this.thrsNormal.heart.night.timeLow =
          this.thrsNormalDefault.heart.night.timeLow;
      if (this.thrsNormalTemp.heart.night.timeUp != null)
        this.thrsNormal.heart.night.timeUp =
          this.thrsNormalTemp.heart.night.timeUp;
      else
        this.thrsNormal.heart.night.timeUp =
          this.thrsNormalDefault.heart.night.timeUp;
      this.norShowChange.heart.nightTime = false;
      this.setDefaultThrsTime();
    },
    heartNightReset() {
      var that = this;
      this.$confirm({
        title: "即将重置为初始默认值，确认重置吗？",
        okText: "重置",
        onOk() {
          that.thrsNormal.heart.night.bpmLow =
            that.thrsNormalDefault.heart.night.bpmLow;
          that.thrsNormal.heart.night.bpmUp =
            that.thrsNormalDefault.heart.night.bpmUp;
          that.thrsNormal.heart.night.timeLow =
            that.thrsNormalDefault.heart.night.timeLow;
          that.thrsNormal.heart.night.timeUp =
            that.thrsNormalDefault.heart.night.timeUp;
          that.thrsNormalTemp.heart.night.bpmLow = null;
          that.thrsNormalTemp.heart.night.bpmUp = null;
          that.thrsNormalTemp.heart.night.timeLow = null;
          that.checkConflict();
          that.thrsNormalTemp.heart.night.timeUp = null;
          that.setDefaultThrsTime();
        },
      });
    },
    strToTime: function (value) {
      var sec = value;
      var min = 0;
      var hour = 0;
      if (sec > 59) {
        min = parseInt(sec / 60);
        sec = parseInt(sec % 60);
      }
      if (min > 59) {
        hour = parseInt(min / 60);
        min = parseInt(min % 60);
      }
      sec < 10 ? (sec = "0" + sec) : (sec = sec);
      min < 10 ? (min = "0" + min) : (min = min);
      hour < 10 ? (hour = "0" + hour) : (hour = hour);
      return hour + ":" + min + ":" + sec;
    },
    timeToStr: function (value) {
      var hour = parseInt(value.slice(0, 2));
      var min = parseInt(value.slice(3, 5));
      var sec = parseInt(value.slice(6, 8));
      return (hour * 3600 + min * 60 + sec).toString();
    },
    checkConflict() {
      if (
        (this.thrs.breathBpm >= this.thrsNormal.breath.day.bpmLow &&
          this.thrs.breathBpm <= this.thrsNormal.breath.day.bpmUp) ||
        (this.thrs.breathBpm >= this.thrsNormal.breath.night.bpmLow &&
          this.thrs.breathBpm <= this.thrsNormal.breath.night.bpmUp)
      )
        this.conflictValues.breath = true;
      else this.conflictValues.breath = false;
      if (
        (this.thrs.heartBpm >= this.thrsNormal.heart.day.bpmLow &&
          this.thrs.heartBpm <= this.thrsNormal.heart.day.bpmUp) ||
        (this.thrs.heartBpm >= this.thrsNormal.heart.night.bpmLow &&
          this.thrs.heartBpm <= this.thrsNormal.heart.night.bpmUp)
      )
        this.conflictValues.heart = true;
      else this.conflictValues.heart = false;
      if (
        (this.thrs.heartBraBpm >= this.thrsNormal.heart.day.bpmLow &&
          this.thrs.heartBraBpm <= this.thrsNormal.heart.day.bpmUp) ||
        (this.thrs.heartBraBpm >= this.thrsNormal.heart.night.bpmLow &&
          this.thrs.heartBraBpm <= this.thrsNormal.heart.night.bpmUp)
      )
        this.conflictValues.heartBra = true;
      else this.conflictValues.heartBra = false;
      var t1 = this.$moment(this.thrsNormal.breath.day.timeLow, "hh:mm");
      var t2 = this.$moment(this.thrsNormal.breath.day.timeUp, "hh:mm");
      var t3 = this.$moment(this.thrsNormal.breath.night.timeLow, "hh:mm");
      var t4 = this.$moment(this.thrsNormal.breath.night.timeUp, "hh:mm");
      if (t1.diff(t4, "minutes") != 1 || t3.diff(t2, "minutes") != 1)
        this.conflictValues.breathThrs = true;
      else this.conflictValues.breathThrs = false;
      var t5 = this.$moment(this.thrsNormal.heart.day.timeLow, "hh:mm");
      var t6 = this.$moment(this.thrsNormal.heart.day.timeUp, "hh:mm");
      var t7 = this.$moment(this.thrsNormal.heart.night.timeLow, "hh:mm");
      var t8 = this.$moment(this.thrsNormal.heart.night.timeUp, "hh:mm");
      if (t5.diff(t8, "minutes") != 1 || t7.diff(t6, "minutes") != 1)
        this.conflictValues.heartThrs = true;
      else this.conflictValues.heartThrs = false;
    },
    getAlarmData() {
      this.$post(
        "api/vital-signs-alarm/select",
        {
          tenantId: this.activeTenantId,
        },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.alarmData = res.data;
              console.log("hello1", this.alarmData);
              this.thrs.outBed = this.strToTime(this.alarmData[0].continued);
              this.thrs.fall = this.strToTime(this.alarmData[1].continued);
              this.thrs.toitet = this.strToTime(this.alarmData[6].continued);
              this.thrs.breathBpm = parseInt(this.alarmData[2].bpm);
              this.thrs.breath = this.strToTime(this.alarmData[2].continued);
              this.thrs.apneaMm = parseFloat(this.alarmData[3].bpm);
              this.thrs.apnea = this.strToTime(this.alarmData[3].continued);
              this.thrs.heartBpm = parseInt(this.alarmData[5].bpm);
              this.thrs.heart = this.strToTime(this.alarmData[5].continued);
              this.thrs.heartBraBpm = parseInt(this.alarmData[4].bpm);
              this.thrs.heartBra = this.strToTime(this.alarmData[4].continued);
              
              this.alarmData[0].enable == 1
                ? (this.switchCheck.outBed = true)
                : (this.switchCheck.outBed = false);
              this.alarmData[1].enable == 1
                ? (this.switchCheck.fall = true)
                : (this.switchCheck.fall = false);
                  this.alarmData[1].methodsList[0].enable == 1
                ? (this.switchCheck.phoneAlarm = true)
                : (this.switchCheck.phoneAlarm = false);
                  this.alarmData[6].methodsList[0].enable == 1
                ? (this.switchCheck.toitetPhoneAlarm = true)
                : (this.switchCheck.toitetPhoneAlarm = false);
              this.alarmData[2].enable == 1
                ? (this.switchCheck.breath = true)
                : (this.switchCheck.breath = false);
							this.alarmData[2].methodsList[0].enable == 1
                ? (this.switchCheck.breathPhoneAlarm = true)
                : (this.switchCheck.breathPhoneAlarm = false);
              this.alarmData[3].enable == 1
                ? (this.switchCheck.apnea = true)
                : (this.switchCheck.apnea = false);
							this.alarmData[3].methodsList[0].enable == 1
                ? (this.switchCheck.apneaPhoneAlarm = true)
                : (this.switchCheck.apneaPhoneAlarm = false);
              this.alarmData[5].enable == 1
                ? (this.switchCheck.heart = true)
                : (this.switchCheck.heart = false);
							this.alarmData[5].methodsList[0].enable == 1
                ? (this.switchCheck.heartPhoneAlarm = true)
                : (this.switchCheck.heartPhoneAlarm = false);
              this.alarmData[4].enable == 1
                ? (this.switchCheck.heartBra = true)
                : (this.switchCheck.heartBra = false);
							this.alarmData[4].methodsList[0].enable == 1
                ? (this.switchCheck.heartBraPhoneAlarm = true)
                : (this.switchCheck.heartBraPhoneAlarm = false);
              this.alarmData[6].enable == 1
                ? (this.switchCheck.toitet = true)
                : (this.switchCheck.toitet = false);
            } else {
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    getMonitoringData() {
      this.$post(
        "api/real-time-monitoring/select",
        {
          tenantId: this.activeTenantId,
        },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log("hello22", res.data);
              this.monitoringData = res.data;
              this.thrsNormal.breath.day.bpmLow = parseInt(
                this.monitoringData[0].startBpm
              );
              this.thrsNormal.breath.day.bpmUp = parseInt(
                this.monitoringData[0].endBpm
              );
              this.thrsNormal.breath.day.timeLow =
                this.monitoringData[0].startTime;
              this.thrsNormal.breath.day.timeUp =
                this.monitoringData[0].endTime;
              this.thrsNormal.breath.night.bpmLow = parseInt(
                this.monitoringData[1].startBpm
              );
              this.thrsNormal.breath.night.bpmUp = parseInt(
                this.monitoringData[1].endBpm
              );
              this.thrsNormal.breath.night.timeLow =
                this.monitoringData[1].startTime;
              this.thrsNormal.breath.night.timeUp =
                this.monitoringData[1].endTime;
              this.thrsNormal.heart.day.bpmLow = parseInt(
                this.monitoringData[2].startBpm
              );
              this.thrsNormal.heart.day.bpmUp = parseInt(
                this.monitoringData[2].endBpm
              );
              this.thrsNormal.heart.day.timeLow =
                this.monitoringData[2].startTime;
              this.thrsNormal.heart.day.timeUp = this.monitoringData[2].endTime;
              this.thrsNormal.heart.night.bpmLow = parseInt(
                this.monitoringData[3].startBpm
              );
              this.thrsNormal.heart.night.bpmUp = parseInt(
                this.monitoringData[3].endBpm
              );
              this.thrsNormal.heart.night.timeLow =
                this.monitoringData[3].startTime;
              this.thrsNormal.heart.night.timeUp =
                this.monitoringData[3].endTime;
              this.monitoringData[0].enable == 1
                ? (this.switchCheck.realTimeMon = true)
                : (this.switchCheck.realTimeMon = false);
              this.checkConflict();
            } else {
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    getHealthBigData() {
      this.$post(
        "api/health-big-data/select",
        {
          tenantId: this.activeTenantId,
        },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log("hello33", res.data);
              this.healthBigData = res.data;
              this.switchCheck.healthReport =
                this.healthBigData[0].enable == 1 ? true : false;
              this.switchCheck.healthReportCheck =
                this.healthBigData[1].enable == 1 ? true : false;
              this.switchCheck.checkInfo =
                this.healthBigData[2].enable == 1 ? true : false;
              this.switchCheck.healthInfo =
                this.healthBigData[3].enable == 1 ? true : false;
              this.switchCheck.workEffi =
                this.healthBigData[4].enable == 1 ? true : false;
              this.switchCheck.opeData =
                this.healthBigData[5].enable == 1 ? true : false;
              this.switchCheck.realTimeOpe =
                this.healthBigData[6].enable == 1 ? true : false;
              this.switchCheck.fourG_check =
                this.healthBigData[7].enable == 1 ? true : false;
              console.log(this.switchCheck);
              this.$forceUpdate()
            } else {
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    setAlarmData() {
      console.log("112", this.activeAlarmData);
      this.$post(
        "api/vital-signs-alarm/update",
        this.activeAlarmData,
        (res) => {
          if (res.code == 0) {
            // this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    setMonitoringData() {
      this.$post(
        "api/real-time-monitoring/update",
        this.activeMonitoringData,
        (res) => {
          if (res.code == 0) {
            // this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    setHealthBigData() {
      this.$post(
        "api/health-big-data/update",
        this.activeHealthBigData,
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },

    // 获取表格数据
    getTableData() {
      let param;
	  if (this.searchType > 0) {
		if (this.searchType == 1) {
			param = {
				pageNum: this.pageNum, // 当前页
				pageSize: this.pageSize, // 每页默认20条
				name: this.searchVal
			};
		} else {
			param = {
				pageNum: this.pageNum, // 当前页
				pageSize: this.pageSize, // 每页默认20条
				snCode: this.searchVal2
			};
		}
	  } else {
		param = {
			pageNum: this.pageNum, // 当前页
			pageSize: this.pageSize, // 每页默认20条
      	};
	  }
      this.$get(
        "/api/tenant",
        param,
        (res) => {
          if (res.code == 0) {
            if (res.data.records) {
              for (var i = 0; i < res.data.records.length; i++) {
                res.data.records[i].index = i;
              }
              this.tableData = res.data.records;
              this.total = res.data.total;
            } else {
              this.tableData = [];
              this.total = res.data.total;
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    record(record) {
      console.log(record.index % 2);
      if (record.index % 2 === 1) return "table-color-dust";
    },
    // 分页
    pageChange(e) {
      console.log(e);
      this.pageNum = e;
      this.getTableData();
    },
    // 搜索
    onSearch() {
		if (!this.searchVal || this.searchVal == '') {
			return
		}
	  if (this.searchVal && this.searchVal.length > 0) {
		this.searchType = 1;
	  }
	  this.getTableData();
    },
	onSearch2() {
		if (!this.searchVal2 || this.searchVal2 == '') {
			return
		}
	  if (this.searchVal2 && this.searchVal2.length > 0) {
		this.searchType = 2;
	  }
	  this.getTableData();
    },
    // 返回
    goBack() {
      this.searchVal = "";
	  this.searchVal2 = "";
      this.getTableData();
      this.searchType = 0;
    },
    // 新增机构按钮
    addMechanismBtn(e) {
      this.typeNum = e;
      this.addMechanismPopup = true;
      this.nameColor = "#BFBFBF";
      this.nameIcon = false;
      this.webColor = "#BFBFBF";
      this.webIcon = false;
      this.addListData.name = "";
      this.addListData.website = "";
      this.webTips = "非必填";
    },
    // 新增取消
    addMechanismOff() {
      this.addMechanismPopup = false;
    },
    // 确定新增或修改
    addMechanismOk() {
      let nameReg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
      if (this.addListData.name) {
        if (
          nameReg.test(this.addListData.name) &&
          this.addListData.name.length < 21
        ) {
          this.nameColor = "#BFBFBF";
          this.nameIcon = false;
        } else {
          this.nameColor = "#FF4D4F";
          this.nameIcon = true;
          return;
        }
      } else {
        this.nameColor = "#FF4D4F";
        this.nameIcon = true;
        return;
      }

      let re =
        /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
      if (
        !re.test(this.addListData.website) &&
        this.addListData.website != ""
      ) {
        this.webColor = "#FF4D4F";
        this.webIcon = true;
        this.webTips = "请输入正确的网址";
        return;
      }

      if (this.typeNum == 1) {
        this.loading = true;
        this.$post(
          "/api/tenant",
          { name: this.addListData.name, siteUrl: this.addListData.website },
          (res) => {
            if (res.code == 0) {
              this.$message.success("添加成功");
              this.addMechanismPopup = false;
              this.getTableData();
              this.addListData = {
                name: "", // 机构名称
                website: "",
              };
              this.nameColor = "#BFBFBF";
              this.nameIcon = false;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            console.log(err);
            // this.$message.error("服务端发生异常");
          }
        );
      } else {
        this.loading = true;
        this.$put(
          "/api/tenant",
          {
            id: this.typeId,
            name: this.addListData.name,
            siteUrl: this.addListData.website,
          },
          (res) => {
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.addMechanismPopup = false;
              this.getTableData();
              this.addListData = {
                name: "", // 机构名称
                website: "",
              };
              this.nameColor = "#BFBFBF";
              this.nameIcon = false;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            console.log(err);
            // this.$message.error("服务端发生异常");
          }
        );
      }
    },
    // 修改按钮
    editBtn(e, scope) {
      this.typeNum = e;
      this.typeId = scope.id;
      this.addListData.name = scope.name;
      this.addListData.website = scope.siteUrl;
      this.addMechanismPopup = true;
      this.nameColor = "#BFBFBF";
      this.nameIcon = false;
    },
    // 机构管理员按钮
    adminUserBtn(num, scope) {
      this.adminUserType = num;
      this.adminUserPopup = true;
      this.scope = scope;
      if (num == 2) {
        this.adminUserList.name = scope.adminUser.name; // 姓名
        this.adminUserList.phone = scope.adminUser.mobile; // 手机号
        this.adminUserList.password = ""; // 密码
      }
    },
    // 取消机构管理员
    adminUserOff() {
      this.adminUserPopup = false;
      this.adminUserList = {
        name: "", // 姓名
        phone: "", // 手机号
        password: "", // 密码
      };
      this.adminNameTips = "姓名只支持字母、数字或汉字，最多可输入20个字符";
      this.nameColor = "#BFBFBF";
      this.nameIcon = false;
      this.phoneColor = "#BFBFBF";
      this.phoneIcon = false;
      this.passwordColor = "#BFBFBF";
      this.passwordIcon = false;
    },
    // 新增修改
    adminUserOk() {
      let nameReg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
      // 姓名验证
      if (this.adminUserList.name) {
        if (
          nameReg.test(this.adminUserList.name) &&
          this.adminUserList.name.length < 21
        ) {
          this.adminNameTips = "姓名只支持字母、数字或汉字，最多可输入20个字符";
          this.nameColor = "#BFBFBF";
          this.nameIcon = false;
        } else {
          this.adminNameTips = "姓名只支持字母、数字或汉字，最多可输入20个字符";
          this.nameColor = "#FF4D4F";
          this.nameIcon = true;
          return;
        }
      } else {
        this.adminNameTips = "姓名不可为空";
        this.nameColor = "#FF4D4F";
        this.nameIcon = true;
        return;
      }
      let phoneReg = /^1[3456789]\d{9}$/;
      // 手机号验证
      if (this.adminUserList.phone) {
        if (phoneReg.test(this.adminUserList.phone)) {
          this.phoneColor = "#BFBFBF";
          this.phoneIcon = false;
        } else {
          this.phoneTips = "请输入正确的手机号码";
          this.phoneColor = "#FF4D4F";
          this.phoneIcon = true;
          return;
        }
      } else {
        this.phoneTips = "手机号不可为空";
        this.phoneColor = "#FF4D4F";
        this.phoneIcon = true;
        return;
      }
      // 密码验证
      if (this.adminUserList.password) {
        this.passwordColor = "#BFBFBF";
        this.passwordIcon = false;
      } else {
        this.passwordColor = "#FF4D4F";
        this.passwordIcon = true;
        this.passwordTips = "密码不可为空";
        return;
      }
      var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      if (reg.test(this.adminUserList.password)) {
        this.passwordColor = "#FF4D4F";
        this.passwordIcon = true;
        this.passwordTips = "密码仅支持数字和英文";
        return;
      } else {
        this.passwordColor = "#BFBFBF";
        this.passwordIcon = false;
      }
      if (this.adminUserType == 1) {
        let param = {
          name: this.adminUserList.name, // 姓名
          mobile: this.adminUserList.phone, // 手机号
          password: this.adminUserList.password, // 密码
          tenantId: this.scope.id,
        };
        this.loading = true;
        this.$post(
          "/api/tenant/admin",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success("添加成功");
              this.adminUserPopup = false;
              this.getTableData();
              this.adminUserList = {
                name: "", // 姓名
                phone: "", // 手机号
                password: "", // 密码
              };
              this.adminNameTips =
                "姓名只支持字母、数字或汉字，最多可输入20个字符";
              this.nameColor = "#BFBFBF";
              this.nameIcon = false;
              this.phoneColor = "#BFBFBF";
              this.phoneIcon = false;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            console.log(err);
            // this.$message.error("服务端发生异常");
          }
        );
      } else {
        let param = {
          name: this.adminUserList.name, // 姓名
          mobile: this.adminUserList.phone, // 手机号
          password: this.adminUserList.password, // 密码
          tenantId: this.scope.id,
          userId: this.scope.adminUser.userId,
        };
        this.loading = true;
        this.$put(
          "/api/tenant/admin",
          param,
          (res) => {
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.adminUserPopup = false;
              this.getTableData();
              this.adminUserList = {
                name: "", // 姓名
                phone: "", // 手机号
                password: "", // 密码
              };
              this.adminNameTips =
                "姓名只支持字母、数字或汉字，最多可输入20个字符";
              this.nameColor = "#BFBFBF";
              this.nameIcon = false;
              this.phoneColor = "#BFBFBF";
              this.phoneIcon = false;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            console.log(err);
            // this.$message.error("服务端发生异常");
          }
        );
      }
    },
    goUrl(url) {
      window.open(url);
    },
    // 更换主题按钮
    replaceThemeBtn(scope) {
      console.log(scope);
      this.replaceThemePopup = true;
      this.tenantId = scope.id;
      this.bannerUrl = {
        response: {
          data: scope.theme.bannerUrl,
        },
      };
      this.fileList = [
        {
          uid: 1,
          name: "xxx.png",
          status: "done",
          url: scope.theme.bannerUrl,
        },
      ];
      this.backGroundColor = scope.theme.bannerColor
        ? scope.theme.bannerColor
        : "linear-gradient(to left, #2DC1FF, #1890FF)";
      console.log(this.fileList);
    },
    // 更换主题取消
    replaceThemeOff() {
      this.replaceThemePopup = false;
      this.colorHide = false;
      this.backGroundColor = "";
    },
    // 确定更换主题
    replaceThemeOk() {
      let param = {
        bannerColor: this.backGroundColor,
        bannerUrl: this.bannerUrl.response.data,
        tenantId: this.tenantId,
      };
      this.loading = true;
      this.$put(
        "/api/tenant/theme",
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success("修改成功！");
            this.replaceThemePopup = false;
            this.getTableData();
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 禁用or启用
    statusBtn(type, scope) {
      let param = {
        status: type == 1 ? 0 : 1,
        tenantId: scope.id,
      };
      this.$put("/api/tenant/status", param, (res) => {
        if (res.code == 0) {
          this.getTableData();
          this.$message.success(type == 1 ? "已禁用" : "已启用");
        }
      });
    },
    handleChange({ file, fileList, event }) {
      console.log(file);
      console.log(fileList);
      console.log(event);
      // if(fileList.response.code == 0){
      this.bannerUrl = file;
      // }else{
      //     this.bannerUrl = '';
      // }
      this.fileList = fileList;
    },
    // 预览关闭
    handleCancel() {
      this.previewVisible = false;
    },
    // 更改
    editThemeBtn() {
      this.fileList = [];
    },
    // 查看监测仪总数
    deviceCntClick(scope) {
      this.$router.push({
        path: "/superAdmin/deviceCntNum",
        query: {
          id: scope.id,
        },
      });
      Global.$emit("handleName", {
        e: scope.name,
        type: 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main::v-deep {
  margin-top: 20px;
  .ant-table-thead th {
    background-color: #f0f0f0;
  }
  .table-color-dust {
    background-color: #fafafa;
  }
  .topBlock {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .searchTitle {
      color: #262626;
      .colorTitle {
        color: #1890ff;
      }
      span:last-child {
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }
  .ant-card {
    padding: 15px 20px;
    border-radius: 8px;
    .ant-card-body {
      padding: 0;
    }
  }
  .add {
    span {
      color: #1890ff;
      cursor: pointer;
    }
  }
}
.login_input {
  display: flex;
  position: relative;
  width: 100%;
  height: 16px;
  padding-bottom: 5px;
  border-bottom: 1px solid;
  box-sizing: content-box;
  img {
    width: 16px;
    height: 16px;
    margin: 0 22px 0 16px;
  }
  input {
    flex: 1;
    border: 0; // 去除未选中状态边框
    outline: none; // 去除选中状态边框
    background-color: rgba(0, 0, 0, 0) !important;
    padding-right: 46px;
    height: 16px !important;
    line-height: 16px !important;
  }
  input:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
  }
  input::-webkit-input-placeholder {
    color: #bfbfbf;
  }
  input:-moz-placeholder {
    color: #bfbfbf;
  }
  input::-moz-placeholder {
    color: #bfbfbf;
  }
  input:-ms-input-placeholder {
    color: #bfbfbf;
  }
}
.tips {
  font-size: 14px;
  line-height: 20px;
}
.adminUser {
  .ant-form-item {
    margin-bottom: 40px;
  }
  .tips {
    margin-bottom: 0;
  }
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}
.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.editTheme {
  color: #1890ff;
  font-size: 14px;
  margin: 10px 0 0 15px;
  display: inline-block;
  height: 26px;
  cursor: pointer;
}
.jianyi {
  color: #8c8c8c;
  font-size: 14px;
  margin: 10px 0 0 15px;
}
.backgroundColor {
  display: flex;
  .colorBox {
    width: 280px;
    height: 32px;
    border: 1px solid #d9d9d9;
    padding: 3px 5px;
    box-sizing: border-box;
    position: relative;
    border-radius: 4px;
    .backColor {
      display: flex;
      .anticon {
        line-height: 32px;
        color: #bebebe;
        font-size: 14px;
        margin-left: 5px;
      }
      .colorTile {
        width: 100%;
        height: 24px;
        text-align: right;
      }
    }
    .colorList {
      position: absolute;
      top: 32px;
      left: 0;
      width: 280px;
      background: #ffffff;
      z-index: 2000;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      transition: all 0.2s ease-in-out;
      .colorItem {
        width: 100%;
        cursor: pointer;
        padding: 5px 26px 5px 5px;
        div {
          height: 24px;
        }
      }
      .colorItem:nth-of-type(1) {
        div{
          border: 2px solid #F0F0F0;
        }
      }
      .colorItem:hover {
        background: #e6f7ff;
      }
    }
  }
}
.ftitles {
  background-color: #20a3fe;
  color: #ffffff;
  text-align: center;
  width: 150px;
  padding: 15px 20px 15px 20px;
  position: relative;
  left: -24px;
}
table {
}
tr {
  height: 40px;
  text-align: center;
}
.tableContent {
  position: relative;
  // top: 10px;
  font-weight: 500;
}
.calDot {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  background-color: #1890ff;
  display: inline-block;
  position: relative;
  top: -1px;
  left: -8px;
}
.bedItem {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  float: right;
  left: -10px;
  top: -3px;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
  // padding: 6px 12px;
  width: 160px;
  background: #e6f7ff;
  color: #1890ff;
  // margin-bottom: 10px;
  // margin-right: 10px;
  // padding: 0 12px;
  span {
    flex: 1;
    text-align: left;
    margin-right: 6px;
  }
}
.bedItem:hover {
  background: #bae7ff;
}
.bedItemDisabled {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  float: right;
  left: -10px;
  top: -3px;
  height: 32px;
  line-height: 32px;
  cursor: not-allowed;
  // padding: 6px 12px;
  width: 160px;
  background: #f5f5f5;
  color: #b7b7b7;
  // margin-bottom: 10px;
  // margin-right: 10px;
  // padding: 0 12px;
  span {
    flex: 1;
    text-align: left;
    margin-right: 6px;
  }
}
.tableIcon {
  color: #1890ff;
  font-size: 20px;
  cursor: pointer;
  // flex: 1;
  position: relative;
  top: 2px;
}
.tableIcon:hover {
  color: #0072db;
}
.tableIconDisabled {
  color: #b7b7b7;
  font-size: 20px;
  cursor: not-allowed;
  // flex: 1;
  position: relative;
  top: 2px;
}
.thrsList {
  text-align: left;
  padding-left: 50px;
  position: relative;
  top: 3px;
}
.bor2Px{
  border: 2px solid #F0F0F0 !important;
}


.super_admin-func_set_modal {
	.fsm-header {
		display: flex;
		align-items: center;
		.fsm-header-dot {
			width: 14px;
			height: 14px;
			border: 4px solid #4A7CE8;
			border-radius: 50%;
			margin-right: 8px;
		}
		.fsm-header-title {
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			font-size: 16px;
			color: #1F2635;
			line-height: 22px;
		}
	}
	.fsm-card {
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: 2px;
		margin-top: 8px;
		.fsm-card-header {
			display: flex;
			align-items: center;
			margin-top: 12px;
			.fsm-card-header-border {
				width: 4px;
				height: 20px;
				background: rgba(74, 124, 232, 0.5);
				border-radius: 0px 2px 2px 0px;
				margin-right: 12px;
			}
			.fsm-card-header-title {
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 14px;
				color: #1F2635;
				line-height: 24px;
			}
		}
		.fsm-card-table {
			margin-left: 16px;
			margin-right: 16px;
			flex: 1;
			width: unset;
			margin-top: 8px;
			display: flex;
			flex-direction: column;
			.fsm-card-table-header {
				background: rgba(240, 240, 240, 1);
				border-top: 1px solid #E8E8E8;
				border-left: 1px solid #E8E8E8;
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 14px;
				color: #1F2635;
				line-height: 24px;
				padding-left: 16px;
				height: 40px;
				display: flex;
				align-items: center;
			}
			.fsm-card-table-header_sub {
				font-family: PingFangSC, PingFang SC;
				font-weight: 600;
				font-size: 14px;
				color: #1F2635;
				line-height: 24px;
				display: flex;
				align-items: center;
				.fsm-card-table-header_sub-item_1 {
					width: 300px;
					border-top: 1px solid #E8E8E8;
					border-left: 1px solid #E8E8E8;
					padding-left: 16px;
					height: 40px;
					display: flex;
					align-items: center;
				}
				.fsm-card-table-header_sub-item_2 {
					flex: 1;
					border-top: 1px solid #E8E8E8;
					border-left: 1px solid #E8E8E8;
					padding-left: 16px;
					height: 40px;
					display: flex;
					align-items: center;
				}
			}
			.fsm-card-table-row {
				display: flex;
				.fsm-card-table-row-item_1 {
					width: 300px;
					border-top: 1px solid #E8E8E8;
					border-left: 1px solid #E8E8E8;
					height: 40px;
					display: flex;
					align-items: center;
					padding-left: 16px;
					padding-right: 16px;
					justify-content: space-between;
				}
				.fsm-card-table-row-item_2 {
					flex: 1;
					border-top: 1px solid #E8E8E8;
					border-left: 1px solid #E8E8E8;
					height: 40px;
					display: flex;
					align-items: center;
					padding-left: 16px;
				}
				.fsm-card-table-row-text_1 {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #1F2635;
					line-height: 24px;
				}
				.fsm-card-table-row-text_1_disabled {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #b7b7b7;
					line-height: 24px;
				}
				.fsm-card-table-row-split_line {
					width: 1px;
					height: 100%;
					background: rgba(232, 232, 232, 1);
				}
				.fsm-card-table-row-edit {
					border-left: 1px solid #E8E8E8;
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 268px;
					height: 100%;
					margin-left: 16px;
					.fsm-card-table-row-edit-left {
						flex: 1;
						margin-left: 16px;
					}
					.fsm-card-table-row-edit-right {
						color: #1890ff;
						font-size: 20px;
						cursor: pointer;
						margin-right: 16px;
					}
					.fsm-card-table-row-edit-righ:hover {
						color: #0072db;
					}
					.fsm-card-table-row-edit-right_disabled {
						color: #b7b7b7;
						font-size: 20px;
						pointer-events: none;
						cursor: not-allowed;
						margin-right: 16px;
					}
				}
				.fsm-card-table-row-reset_edit {
					cursor: pointer;
				}
				.fsm-card-table-row-reset_btn {
					display: flex;
					align-items: center;
					padding-left: 16px;
					border-left: 1px solid #E8E8E8;
					height: 100%;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #1890FF;
					line-height: 24px;
					cursor: pointer;
				}
				.fsm-card-table-row-reset_btn_disabled {
					color: rgba(24, 144, 255, 0.2);
					pointer-events: none;
					cursor: not-allowed;
				}
				.text_color_ff4d4f {
					color: #ff4d4f;
				}
			}
		}
		.fsm-card-border_right {
			border-right: 1px solid rgba(232, 232, 232, 1);
		}
		.fsm-card-border_bottom {
			border-bottom: 1px solid rgba(232, 232, 232, 1);
		}
		.fsm-card-color_FAFAFA{
			background: #FAFAFA;
		}
	}
}

</style>

<style lang="scss">
.super_admin-func_set_modal {
	.ant-modal-body {
		background: #F3F4F7;
	}
	.ant-modal-footer {
		background: rgba(243, 244, 247, 1);
		border-top: unset;
	}
}
</style>